import _ from "lodash";
import React, { createRef, useEffect, useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import classes from "./AddPostDetails.scss";
import ScreenPanel from "../../ScreenPanel";
import { connect } from "react-redux";
import CreatePost from "Post/routes/CreatePost/CreatePost";
import TextAreaInput from "UIComponents/TextAreaInput";
import MediaPlaceholder from "UIComponents/MediaPlaceholder";
import PYPElements from "UIComponents/PYPElements";
import withLoader from "UIComponents/GqlWithLoader";
import MediaModal from "UIComponents/MediaModal";
import I18nHOC from "UIComponents/I18nHOC";
import Note from "UIComponents/Note";
import AudioRecorderSelector from "UIComponents/AudioRecorderSelector";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import UIModal from "UIComponents/UIModal";
import UIBaseContentEditable from "UIComponents/UIBaseContentEditable";
import DisabledStateTooltip from "AppComponents/DisabledStateTooltip";

import { AttachmentList } from "Attachment/";
import { EditInWorkbookSvg } from "SvgComponents";
import classnames from "classnames";
import { colors } from "Constants";
import {
  TaggedStudentDetails,
  TaggedPracticesV2,
  UnitDetails,
  TaggedFolders,
} from "Post/components";
import {
  getFieldList,
  getTaggableElements,
} from "modules/TaggableElementsUtils";
import {
  getSharedWithString,
  enableTermRestriction,
  getCombinedDateAndTimeMoment,
  isPortfolioAIEnabledAndIsJournalRoute,
  isDPSubjectJournalEnabled,
  isGlobalHeaderOnMultipleScreensEnabled,
} from "Post/utils";
import { getSettingValue } from "modules/PermissionModule";

import { getElementData } from "modules/ElementValueUtils";
import { getAttachmentsByTypeFromAttachmentArr, getCurrentTerm } from "Utils";
import { compose, graphql } from "lib/apolloClient";
import {
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
} from "Constants/stringConstants";

import {
  StudentAddOutlined,
  GoalsOutlined,
  FolderOutlined,
  ScopeAndSequenceOutlined,
  AddCircleOutlined,
  PencilLineOutlined,
  TeacherShareOutlined,
  ChevronRightOutlined,
  MicrophoneOutlined,
  AssessmentApplicableOutlined,
  PublishOutlined,
  DeleteOutlined,
  CloseOutlined,
  LearningExperienceColored,
  UnitPlanOutlined,
  CalendarScheduleOutlined,
} from "@toddle-edu/ds-icons";
import Accordian from "UIComponents/Accordian";
import { StudentResponseProfile } from "../StudentResponse/StudentResponse";
import { getStudentAssignmentDetailsQuery } from "ClassRoom/modules/ClassRoomQuery";
import { getStudentAssignmentDetailsFromCache } from "ClassRoom/modules/ClassRoomGraphqlHelpers";
import { Tooltip } from "AppComponents/ArchivedComponents";
import {
  Alert,
  IconButton,
  Button,
  MediaCard,
  Dropdown,
  DropdownMenu,
  SplitButtonDropdown,
  ButtonDisclosure,
  Modal,
  EmptyState,
  TextAreaInput as DSTextAreaInput,
} from "@toddle-edu/ds-web";
import PostRateonLearningGoals from "../PostRateonLearningGoals";
import {
  getCourseUnitQuery,
  getOrganizationAcademicYearsQuery,
  getPostsHavingTaggedGoalsQuery,
} from "AppComponents/Post/modules/PostQuery";
import {
  getCourseUnitFromCache,
  getOrganizationAcademicYearsFromCache,
  getPostsHavingTaggedGoalsQueryFromCache,
} from "AppComponents/Post/modules/PostGraphqlHelpers";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import moment from "moment";
import { showNewTheatreMode } from "Utils/GetTheatreModeType";
import TheatreModeV2 from "UIComponents/TheatreModeV2";
import StudentResponseV2 from "AppComponents/Post/routes/CreatePost/components/Screens/StudentResponseV2";
import SchedulePostModal from "AppComponents/Post/components/SchedulePostModal";
import {
  getUserInfo,
  setToastMsg,
  setGlobalTrayEnabledState,
  enableGlobalHeader,
  disableGlobalHeader,
} from "Login/modules/LoginModule";
import { NoChecklistIllustration } from "@toddle-edu/ds-theme";
import TagPost from "../TagPost/TagPost";
import NoteV2 from "./NoteV2";
import AIInputBox from "./AIInputBox";
import {
  aiGenerateActionsMapping,
  cleanupMessage,
  isEmptyHtmlV2,
} from "./AIInputBox/utils.js";

import { isWindows } from "Utils/DeviceDetectHelpers";
import { getDefaultStudentIdentifierNamePreference } from "modules/CommonSelectors";
import { getToolResponseUserFilter } from "Teacher/routes/Courses/routes/Course/routes/ClassRoom/modules/utils";

const BLANK_ARRAY = [];
const BLANK_OBJECT = {};
const BLANK_STRING = "";

const styles = {
  tagTypePreviousYearStyle: {
    cursor: "not-allowed",
  },
  customProfileCadeStyle: {
    width: "24px",
    height: "24px",
    fontSize: ".7rem",
  },
  customStudentNameStyle: {
    fontSize: "1.4rem",
  },
  studentResponseStyle: {
    marginTop: "0px",
  },
  noteTextAreaStyles: {
    borderWidth: 0,
    padding: 0,
    overflowY: "hidden",
    unicodeBidi: "plaintext",
  },
  responseContainerStyle: {
    paddingBottom: "16px",
    borderWidth: 1,
    borderColor: colors.borderDefault,
    borderRadius: "16px",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
  },
  responseHorizontalCardStyle: {
    width: "192px",
  },
  noGradesConfiguredModalHeader: {
    borderTop: `1px solid ${colors.strokeOne}`,
  },
  noGradesConfiguredModalCancelStyle: { float: "right" },
  modalTitleHeaderStyle: {
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    fontWeight: "600",
    paddingBottom: "24px",
  },
  popoverContainer: {
    zIndex: 1000,
  },
  textArea: {
    borderWidth: 0,
    flexShrink: 0,
    padding: "16px",
    display: "block",
    whiteSpace: "pre-wrap",
    unicodeBidi: "plaintext",
  },
};

const detailInnerContainerStyle = {
  marginBottom: "-8px",
};

// const {
//   REGENERATE,
//   SHORTEN,
//   ELABORATE,
//   SIMPLIFY_LANGUAGE,
//   FIX_SPELLING_GRAMMAR,
//   IMPROVE_LANGUAGE,
//   AUTOGENERATE_CAPTION,
//   ASK_AI_WITHOUT_IMAGE,
//   ASK_AI_ATTACHMENT_CAPTION,
//   ASK_AI_ATTACHMENT_CAPTION_FILLED,
// } = aiGenerateActionsMapping;

// const {
//   KEEP,
//   DISCARD,
//   REPLACE,
//   ADD_BELOW,
//   TRANSLATE,
//   TRANSLATE_BACK,
// } = aiPromptsActionMapping;

const FooterComponent = React.memo(props => {
  const {
    onPublishClick,
    onDraftClick,
    state,
    mode,
    t,
    isPost,
    addButtonLabel,
    userType,
    onMediaCreate,
    onSendForApprovalClick,
    isApprovalRequiredForStudentPosts,
    isAddAllResponsesToJournal,
    onAddAllResponsesToJournal,
    onCloseClick,
    togglePostScheduleModal,
    setScheduleDateTimeDetails,
    scheduleDateTimeDetails,
    canScheduleAPost = false,
    publishedAt,
    createdAt,
    updatePost,
    postDetails,
    postServerObject,
    setToastMsg,
    noteTitle,
    isNote = false,
    isPostTypeImage = false,
    isImageUploading = false,
    isPromptBoxContentPresent,
    isAIResponseGenerating,
    isPromptBoxTextPresent,
    curriculumProgramType,
  } = props;

  const publishDropdownOptions = [
    {
      label: t(
        mode == "edit" && state !== "DRAFT"
          ? "common:update"
          : "journal:publish"
      ),
      key: "PUBLISH_POST",
      icon: <PublishOutlined />,
    },
    {
      label: t("journal:select_date_and_time"),
      key: "SCHEDULE_POST",
      icon: <CalendarScheduleOutlined />,
    },
  ];

  const scheduleDropdownOptions = [
    {
      label: t("common:edit_with_label", {
        label: t("common:scheduled_date"),
        lowercase: true,
      }),
      key: "EDIT_SCHEDULE_DATE",
    },
    {
      label: t("common:unschedule"),
      key: "UNSCHEDULE_POST",
    },
  ];

  const onPublishDropdownOptionClick = value => {
    switch (_.get(value, "key", "")) {
      case "PUBLISH_POST":
        isAddAllResponsesToJournal
          ? onAddAllResponsesToJournal()
          : onPublishClick();
        break;

      case "SCHEDULE_POST":
        if (_.isFunction(togglePostScheduleModal))
          togglePostScheduleModal(true);
        break;

      //---- Edit scheduling option

      case "EDIT_SCHEDULE_DATE":
        if (_.isFunction(togglePostScheduleModal)) {
          togglePostScheduleModal(true);
        }
        break;

      case "UNSCHEDULE_POST":
        if (_.isFunction(updatePost)) {
          setScheduleDateTimeDetails(BLANK_OBJECT);
          updatePost({
            state: "PUBLISHED",
            publishedAt: undefined,
          });
          setToastMsg({
            msg: "toastMsgs:post_unscheduled_successfully",
            type: "success",
          });
        }
        break;
      default:
        break;
    }
  };

  const handleDraftClickLocal = () => {
    updatePost({ publishedAt: undefined });
    onDraftClick();
  };

  const hideSaveAsDraftOptionForInapproval = () => {
    const { createdBy } = postDetails;
    if (createdBy?.type === "student") {
      return false;
    }
    return true;
  };

  //Handle Different footer for post and other media creation based on isPost prop
  //AddButtonLabel only applicable non post media creation
  return (
    <div className={classes.footerButtonContainer}>
      {isPost ? (
        <React.Fragment>
          {/* Show draft button only to teachers */}
          {userType == "staff" &&
            !isAddAllResponsesToJournal &&
            hideSaveAsDraftOptionForInapproval() && (
              <Button
                variant="outlined"
                size="large"
                onClick={handleDraftClickLocal}
                disabled={
                  (isNote && !noteTitle?.trim()) ||
                  (isNote && isEmptyHtmlV2(noteTitle?.trim())) ||
                  (isPostTypeImage
                    ? isImageUploading ||
                      isAIResponseGenerating ||
                      isPromptBoxContentPresent
                    : false)
                }
                testId={"journal-postcreation-saveasdraft"}
              >
                {t("common:save_as_draft")}
              </Button>
            )}
          <div
            className={classnames({
              [classes.footerButtonRightContainer]: true,
              [classes.widthFull]:
                userType == "student" || !hideSaveAsDraftOptionForInapproval(),
            })}
          >
            {/* Show time scheduling dropdown (case: editing scheduled post) */}
            {userType === "staff" &&
            (state === "SCHEDULED" ||
              (!_.isEmpty(scheduleDateTimeDetails?.date) &&
                !_.isEmpty(scheduleDateTimeDetails?.time))) ? (
              <Dropdown
                overlay={
                  <DropdownMenu
                    options={scheduleDropdownOptions}
                    onClick={onPublishDropdownOptionClick}
                    style={{ minWidth: "184px" }}
                    showSelection={true}
                  />
                }
                placement={"topRight"}
                variant={"plain"}
                testId="journal-postcreation-schedule-options"
              >
                <ButtonDisclosure
                  variant="plain"
                  size={"large"}
                  testId="journal-postcreation-schedule-details"
                >
                  {t(
                    getCombinedDateAndTimeMoment(
                      scheduleDateTimeDetails
                    )?.isAfter(moment())
                      ? "common:scheduled_for_with_label"
                      : "journal:set_for_with_label",
                    {
                      label:
                        scheduleDateTimeDetails?.date?.format("MMM DD YYYY") +
                        ", " +
                        scheduleDateTimeDetails?.time?.format("hh:mm A"),
                    }
                  )}
                </ButtonDisclosure>
              </Dropdown>
            ) : null}
            {/* Show send for approval button to students and publish/update post button only to teachers */}
            {userType === "student" ? (
              <Button
                size={"large"}
                isFullWidth
                variant="progressive"
                icon={<PublishOutlined />}
                onClick={
                  isApprovalRequiredForStudentPosts &&
                  !isDPSubjectJournalEnabled(curriculumProgramType)
                    ? onSendForApprovalClick
                    : onPublishClick
                }
                disabled={
                  isPostTypeImage
                    ? isImageUploading ||
                      isPromptBoxContentPresent ||
                      isAIResponseGenerating
                    : false
                }
                testId={"journal-postcreation-rightbutton"}
              >
                {isApprovalRequiredForStudentPosts &&
                !isDPSubjectJournalEnabled(curriculumProgramType)
                  ? t("journal:send_for_approval")
                  : mode === "create"
                  ? t("journal:publish")
                  : t("common:update")}
              </Button>
            ) : (
              <div
                style={{
                  width: !hideSaveAsDraftOptionForInapproval() ? "100%" : "",
                }}
              >
                <ConditionalWrapper
                  condition={
                    // Use same condition in ManageSubjectJournalPost.js for DP support (if needed)
                    userType == "staff" &&
                    !isAddAllResponsesToJournal &&
                    _.includes(["PUBLISHED", "DRAFT"], state) &&
                    (_.isEmpty(scheduleDateTimeDetails?.date) ||
                      _.isEmpty(scheduleDateTimeDetails?.time))
                  }
                  wrapper={
                    <SplitButtonDropdown
                      overlay={
                        <DropdownMenu
                          options={publishDropdownOptions}
                          onClick={onPublishDropdownOptionClick}
                          style={{ minWidth: "184px" }}
                          showSelection={true}
                          testId="journal-postcreation-publish-options"
                        />
                      }
                      placement={"topRight"}
                      variant={"progressive"}
                      disabled={
                        (isNote && !noteTitle?.trim()) ||
                        (isNote && isEmptyHtmlV2(noteTitle?.trim()))
                      }
                      testId="journal-postcreation-publish-dropdown"
                    ></SplitButtonDropdown>
                  }
                  type="wrapperAsElement"
                >
                  <Button
                    variant="progressive"
                    size={"large"}
                    icon={<PublishOutlined />}
                    onClick={
                      isAddAllResponsesToJournal
                        ? onAddAllResponsesToJournal
                        : onPublishClick
                    }
                    disabled={
                      (isNote && !noteTitle?.trim()) ||
                      (isPostTypeImage
                        ? isImageUploading ||
                          isPromptBoxContentPresent ||
                          isAIResponseGenerating
                        : false) ||
                      (isNote && isEmptyHtmlV2(noteTitle?.trim()))
                    }
                    isFullWidth={!hideSaveAsDraftOptionForInapproval()}
                    testId={"journal-postcreation-rightbutton"}
                  >
                    {state == "DRAFT" || mode == "create"
                      ? moment(publishedAt).isAfter(moment())
                        ? t("common:schedule")
                        : t("journal:publish")
                      : t("common:update")}
                  </Button>
                </ConditionalWrapper>
              </div>
            )}
          </div>
        </React.Fragment>
      ) : (
        <Button
          variant="progressive"
          size={"large"}
          isFullWidth={true}
          onClick={onMediaCreate}
          testId={"journal-postcreation-addmedia"}
        >
          {t(addButtonLabel)}
        </Button>
      )}
    </div>
  );
});
FooterComponent.displayName = "Footer";

const TagTypeHelper = React.memo(props => {
  const {
    title,
    dataLength,
    onAddOrEditClick,
    tagTypeStyle,
    icon,
    expandedContent,
    count,
    showTaggedStudents,
    showTaggedItems,
    customTagTypeStyle,
    disabled,
    showDropdownActions = false,
    dropdownOptions = [],
    onDropdownOptionClick,
    showDeleteButton = false,
    isDeleteDisabled = false,
    onDeleteClick,
    showCountAlways = false,
    onTagLearningGoalClick,
    updatePost,
    showTagLearningGoalsModal,
    isRecentPost,
    postsWithGoals = [],
    goToStep,
    isCurrentAcademicYearSelected,
    isArchivedClass,
    isAIResponseGenerating,
    isPromptBoxContentPresent,
    isPromptBoxTextPresent,
    userType,
    testId,
  } = props;

  const tagTypeTextClasses = classnames(classes.tagTypeText, {
    disabled,
  });

  const { t } = useTranslation(["journal", "common"]);
  const [isTagLearningGoalsModalOpen, setShowTagLearningGoalsModal] = useState(
    false
  );

  const tagLearningGoalsOptions = [
    {
      label: t("journal:le_and_assessments"),
      key: TAG_LEARNING_GOALS_FROM_ASSESSMENTS,
      icon: <LearningExperienceColored size={"x-small"} />,
      background: colors.decorativeSurfaceTwoL,
    },
    {
      label: t("common:unit_plural"),
      key: TAG_LEARNING_GOALS_FROM_UNIT,
      icon: <UnitPlanOutlined variant={"link"} />,
      background: colors.decorativeSurfaceOneL,
    },
    {
      label: t("journal:all_pyp_elements"),
      key: TAG_FROM_ALL_LEARNING_GOALS,
      icon: <GoalsOutlined variant="success" />,
      background: colors.surfaceSuccess,
    },
  ];

  const onOptionClick = (e, option) => {
    e?.stopPropagation();
    onTagLearningGoalClick(option.key);
    setShowTagLearningGoalsModal(false);
    updatePost({ showTagLearningGoalsModal: false });
  };

  const TagLearningGoalsModal = () => (
    <Modal
      hasOverlay={true}
      isOpen={isTagLearningGoalsModalOpen || showTagLearningGoalsModal}
      onClose={e => {
        e?.stopPropagation();
        setShowTagLearningGoalsModal(false);
        updatePost({ showTagLearningGoalsModal: false });
      }}
      shouldCloseOnEsc={true}
      width="480px"
      height="600px"
    >
      <Modal.Header title={`${t("journal:tag_pyp_elements")}`} />
      <Modal.Body style={{ paddingTop: "0px", overflowX: "hidden" }}>
        {/* <div style={styles.modalTitleHeaderStyle}>
          {t("journal:select_goals_from")} //removing for DQC change
        </div> */}
        {_.map(tagLearningGoalsOptions, (option, index) => (
          <div>
            <div
              className={classes.learningGoals}
              data-test-id={`journal-postcreation-taglearninggoals-${_.toLower(
                option.key
              )}`}
              style={{
                borderBottom:
                  index === _.size(tagLearningGoalsOptions) - 1
                    ? "none"
                    : `1px solid ${colors.borderSubtle}`,
                paddingBottom:
                  isRecentPost && index == _.size(tagLearningGoalsOptions) - 1
                    ? "none"
                    : "16px",
                cursor: "pointer",
              }}
              onClick={e => {
                onOptionClick(e, option);
              }}
            >
              <div className={classes.learningGoalsTitle}>
                <div
                  className={classes.customHeaderIcon}
                  style={{ backgroundColor: option.background }}
                >
                  {option.icon}
                </div>
                <div className={classes.learningGoalsTitle}>{option.label}</div>
              </div>
              <div style={{ paddingRight: "8px", alignSelf: "end" }}>
                <IconButton
                  icon={<ChevronRightOutlined size={"x-small"} />}
                  variant={"plain"}
                  size={"x-small"}
                  disabled={false}
                  onClick={e => {
                    onOptionClick(e, option);
                  }}
                />
              </div>
            </div>
            {isRecentPost && index === _.size(tagLearningGoalsOptions) - 1 ? (
              <TagPost
                postsWithGoals={postsWithGoals}
                t={t}
                goToStep={goToStep}
              />
            ) : null}
          </div>
        ))}
      </Modal.Body>
    </Modal>
  );

  const onClickPypElement = () => {
    if (
      isPortfolioAIEnabledAndIsJournalRoute(userType) &&
      (isAIResponseGenerating ||
        isPromptBoxContentPresent ||
        isPromptBoxTextPresent)
    ) {
      return;
    }
    if (
      dataLength == 0 &&
      !(!isCurrentAcademicYearSelected || isArchivedClass)
    ) {
      _.isFunction(updatePost) &&
        updatePost({ showTagLearningGoalsModal: true });
    } else if (dataLength === 0 && !showDropdownActions) {
      _.isFunction(onAddOrEditClick) && onAddOrEditClick();
    }
  };
  return (
    <div
      className={classes.tagTypeContainer}
      style={{
        ...customTagTypeStyle,
        ...(tagTypeStyle ? tagTypeStyle : {}),
      }}
      onClick={onClickPypElement}
      data-test-id={testId}
    >
      <div className={classes.tagtypeLeftContainer}>
        <div className={classes.iconContainer}>{icon}</div>
        <div className={tagTypeTextClasses}>{title}</div>
      </div>
      <div className={classes.tagTypeRightContainer}>
        {showTaggedItems && (
          <div>
            {showTaggedStudents ? (
              <div className={classes.expandedContentContainer}>
                {expandedContent}
              </div>
            ) : (
              count &&
              !showCountAlways && (
                <div className={classes.countContainer}>{count}</div>
              )
            )}
          </div>
        )}
        {showCountAlways && count && (
          <div className={classes.countContainer}>{count}</div>
        )}
        <div
          className={classes.tagIconContainer}
          style={tagTypeStyle ? tagTypeStyle : {}}
        >
          {dataLength == 0 ? (
            showDropdownActions ? (
              <>
                <IconButton
                  icon={<AddCircleOutlined size={"xx-small"} />}
                  variant={"plain"}
                  size={"medium"}
                  disabled={disabled}
                  onClick={() => {
                    setShowTagLearningGoalsModal(true);
                    updatePost({ showTagLearningGoalsModal: true });
                  }}
                ></IconButton>
                {showTagLearningGoalsModal ? (
                  <TagLearningGoalsModal
                    isRecentPost={isRecentPost}
                    postsWithGoals={postsWithGoals}
                  />
                ) : null}
              </>
            ) : (
              <IconButton
                icon={<AddCircleOutlined size={"xx-small"} />}
                variant={"plain"}
                size={"medium"}
                disabled={disabled}
                onClick={e => {
                  e?.stopPropagation();
                  if (
                    isPortfolioAIEnabledAndIsJournalRoute(userType) &&
                    (isAIResponseGenerating ||
                      isPromptBoxContentPresent ||
                      isPromptBoxTextPresent)
                  ) {
                    return;
                  }
                  _.isFunction(onAddOrEditClick) && onAddOrEditClick();
                }}
              ></IconButton>
            )
          ) : (
            <React.Fragment>
              {/* EDIT button */}
              <IconButton
                icon={<PencilLineOutlined size={"xx-small"} />}
                variant={"plain"}
                size={"medium"}
                disabled={disabled}
                onClick={e => {
                  e?.stopPropagation();
                  _.isFunction(onAddOrEditClick) && onAddOrEditClick();
                }}
              ></IconButton>

              {/* DELETE button (rendered based on showDeleteButton prop) */}
              {showDeleteButton && (
                <IconButton
                  icon={<DeleteOutlined size={"xx-small"} />}
                  variant={"plain"}
                  size={"medium"}
                  disabled={isDeleteDisabled}
                  onClick={e => {
                    e?.stopPropagation();
                    onDeleteClick();
                  }}
                  style={{ marginLeft: "4px" }}
                ></IconButton>
              )}
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
});

TagTypeHelper.displayName = "TagTypeHelper";

const TagType = React.memo(props => {
  const { dataLength, expandedContent, customExpandedContentStyle } = props;
  const [showTaggedItems, setShowTaggedItems] = useState(true);
  useEffect(() => {
    if (dataLength == 0) setShowTaggedItems(true);
  }, [dataLength]);
  return dataLength == 0 ? (
    <TagTypeHelper {...props} showTaggedItems={showTaggedItems} />
  ) : (
    <Accordian
      hideContainerBorder={true}
      showLabelBorder={false}
      customTitleComponent={
        <TagTypeHelper {...props} showTaggedItems={showTaggedItems} />
      }
      expandedContent={
        <div
          className={classes.tagDetailContainer}
          style={customExpandedContentStyle}
        >
          {expandedContent}
        </div>
      }
      showLeftArrow={true}
      mainContentContainerStyle={{ marginBottom: "0" }}
      headerStyle={{ padding: "0" }}
      getIsExpanded={value => setShowTaggedItems(value)}
    />
  );
});

TagType.displayName = "TagType";

const StudentTag = React.memo(props => {
  const {
    onAddOrEditClick,
    students,
    t,
    isCurrentAcademicYearSelected,
    isArchivedClass,
    isAIResponseGenerating,
    isPromptBoxContentPresent,
    isPromptBoxTextPresent,
    userType,
  } = props;
  const studentsLength = _.get(students, "length", 0);

  const tagOptionClasses = classnames(classes.tagOption, {
    disabled: isArchivedClass,
  });
  return (
    <div className={tagOptionClasses}>
      <ConditionalWrapper
        condition={!isCurrentAcademicYearSelected || isArchivedClass}
        wrapper={
          <DisabledStateTooltip
            isCurrentAcademicYear={isCurrentAcademicYearSelected}
            placement={"left"}
          />
        }
        type="wrapperAsElement"
      >
        <TagType
          title={t("journal:tag_students")}
          dataLength={studentsLength}
          disabled={isArchivedClass || !isCurrentAcademicYearSelected}
          onAddOrEditClick={
            isCurrentAcademicYearSelected && !isArchivedClass
              ? onAddOrEditClick
              : null
          }
          tagTypeStyle={
            !isCurrentAcademicYearSelected
              ? styles.tagTypePreviousYearStyle
              : null
          }
          icon={<StudentAddOutlined size={"xx-small"} />}
          expandedContent={
            studentsLength > 0 && (
              <TaggedStudentDetails
                taggedStudents={students}
                customProfileCadeStyle={styles.customProfileCadeStyle}
                customStudentNameStyle={styles.customStudentNameStyle}
              />
            )
          }
          showTaggedStudents={studentsLength > 0}
          isAIResponseGenerating={isAIResponseGenerating}
          isPromptBoxContentPresent={isPromptBoxContentPresent}
          isPromptBoxTextPresent={isPromptBoxTextPresent}
          userType={userType}
          testId={"journal-postcreation-tagstudents"}
        />
      </ConditionalWrapper>
    </div>
  );
});
StudentTag.displayName = "StudentTag";

const PYPElementDetails = React.memo(props => {
  const {
    unitPlan,
    resourceItem,
    elementData,
    resourceType,
    selectFromAllPYP,
    t,
    taggableElements,
  } = props;

  const detailContainerClass = classnames({
    [classes.detailContainer]: true,
    // [classes.detailContainerBorder]: !!unitPlan || !!resourceItem,
  });

  const dynamicLevelContainerStyle = {
    0: {
      marginTop: "-8px",
    },
    2: {
      marginTop: "0",
    },
  };

  const pypElements = (
    <div className={detailContainerClass}>
      {/* {!selectFromAllPYP && (
        <div className={classes.detailsHeaderText}>
          {t("journal:edit_post_pyp_elements")}
        </div>
      )} */}
      <PYPElements
        elementData={elementData}
        pypTemplateElements={taggableElements}
        customContainerStyle={{
          borderBottom: "none",
          borderTop: `1px solid ${colors.borderSubtle}`,
          padding: "24px 0px",
        }}
        dynamicLevelContainerStyle={dynamicLevelContainerStyle}
      />
    </div>
  );

  if (!!unitPlan || !!resourceItem)
    return (
      <React.Fragment>
        <UnitDetails
          unitPlan={unitPlan}
          resourceItem={resourceItem}
          resourceType={resourceType}
          detailInnerContainerStyle={detailInnerContainerStyle}
        />
        {pypElements}
      </React.Fragment>
    );

  if (!_.isEmpty(elementData)) return pypElements;

  return null;
});

PYPElementDetails.displayName = "PYPElementDetails";

const PYPElementDetailsWithLoader = compose(withLoader)(PYPElementDetails);

const TAG_FROM_ALL_LEARNING_GOALS = "TAG_FROM_ALL_LEARNING_GOALS";
const TAG_LEARNING_GOALS_FROM_UNIT = "TAG_LEARNING_GOALS_FROM_UNIT";
const TAG_LEARNING_GOALS_FROM_ASSESSMENTS =
  "TAG_LEARNING_GOALS_FROM_ASSESSMENTS";

const TAG_LEARNING_GOALS_FROM_POST = "TAG_LEARNING_GOALS_FROM_POST";
class PYPElementTag extends React.PureComponent {
  render() {
    const {
      onAddOrEditClick,
      elementPYP,
      t,
      unitPlan,
      resourceItem,
      elementData,
      resourceType,
      isData,
      isLoading,
      selectFromAllPYP,
      taggableElements,
      learningGoalsCount,
      goToStep,
      updatePost,
      showWarningModal,
      showTagLearningGoalsModal,
      isRecentPost,
      postsWithGoals,
      isCurrentAcademicYearSelected,
      isArchivedClass,
      disableTagLearningGoals,
      isDeleteDisabled,
      isAIResponseGenerating,
      isPromptBoxContentPresent,
      isPromptBoxTextPresent,
      userType,
    } = this.props;
    const elementsLength = _.get(elementPYP, "length", 0);

    const dropdownOptions = [
      {
        isItemGroup: true,
        label: t("journal:select_from"),
        options: [
          {
            label: t("journal:all_pyp_elements"),
            key: TAG_FROM_ALL_LEARNING_GOALS,
          },
          {
            label: t("common:unit_plural"),
            key: TAG_LEARNING_GOALS_FROM_UNIT,
          },
          {
            label: t("journal:le_and_assessments"),
            key: TAG_LEARNING_GOALS_FROM_ASSESSMENTS,
          },
        ],
      },
    ];

    const onTagLearningGoalClick = value => {
      switch (value) {
        case TAG_FROM_ALL_LEARNING_GOALS:
          updatePost({
            selectFromAllPYP: true,
            unitPlan: null,
            resourceId: null,
            resourceType: null,
            resourceItem: undefined,
          });
          break;

        case TAG_LEARNING_GOALS_FROM_UNIT:
          updatePost({
            selectFromAllPYP: false,
            unitPlan: unitPlan,
            resourceId: null,
            resourceType: null,
            resourceItem: undefined,
          });
          break;

        case TAG_LEARNING_GOALS_FROM_ASSESSMENTS:
          updatePost({
            selectFromAllPYP: false,
            unitPlan: _.get(resourceItem, "unitPlan", null),
            resourceId: _.get(resourceItem, "id", null),
            resourceType: _.get(resourceItem, "type", null),
            resourceItem: resourceItem,
          });
          break;
        case TAG_LEARNING_GOALS_FROM_POST:
          updatePost({
            selectFromAllPYP: false,
            unitPlan: null,
            resourceId: null,
            resourceType: null,
            resourceItem: undefined,
            postsWithGoals: postsWithGoals,
          });
          break;
      }
      if (!_.isEmpty(value)) {
        goToStep(value);
      }
    };

    const onDropdownOptionClick = value => {
      switch (_.get(value, "key", "")) {
        case TAG_FROM_ALL_LEARNING_GOALS:
          updatePost({
            selectFromAllPYP: true,
            unitPlan: null,
            resourceId: null,
            resourceType: null,
            resourceItem: undefined,
          });
          break;

        case TAG_LEARNING_GOALS_FROM_UNIT:
          updatePost({
            selectFromAllPYP: false,
            unitPlan: unitPlan,
            resourceId: null,
            resourceType: null,
            resourceItem: undefined,
          });
          break;

        case TAG_LEARNING_GOALS_FROM_ASSESSMENTS:
          updatePost({
            selectFromAllPYP: false,
            unitPlan: _.get(resourceItem, "unitPlan", null),
            resourceId: _.get(resourceItem, "id", null),
            resourceType: _.get(resourceItem, "type", null),
            resourceItem: resourceItem,
          });
          break;
      }
      if (!_.isEmpty(_.get(value, "key", ""))) {
        goToStep(value?.key);
      }
    };
    const pypTagOptionsClasses = classnames(classes.pypTagOptions, {
      disabled: disableTagLearningGoals,
    });
    return (
      <div className={pypTagOptionsClasses}>
        <ConditionalWrapper
          condition={disableTagLearningGoals}
          wrapper={
            <DisabledStateTooltip
              isCurrentAcademicYear={isCurrentAcademicYearSelected}
              placement={"left"}
            />
          }
          type="wrapperAsElement"
        >
          <TagType
            title={t("journal:tag_pyp_elements")}
            dataLength={
              elementsLength ||
              _.keys(unitPlan).length ||
              _.keys(resourceItem).length
            }
            onAddOrEditClick={onAddOrEditClick}
            icon={<GoalsOutlined size={"xx-small"} />}
            expandedContent={
              <PYPElementDetailsWithLoader
                t={t}
                unitPlan={unitPlan}
                resourceItem={resourceItem}
                elementData={elementData}
                resourceType={resourceType}
                isData={isData}
                isLoading={isLoading}
                selectFromAllPYP={selectFromAllPYP}
                taggableElements={taggableElements}
              />
            }
            count={
              learningGoalsCount > 0 &&
              t("journal:count_le_goal", {
                count: learningGoalsCount,
              })
            }
            customExpandedContentStyle={!unitPlan ? { marginTop: "0px" } : {}}
            showDropdownActions={true}
            dropdownOptions={dropdownOptions}
            onDropdownOptionClick={onDropdownOptionClick}
            showDeleteButton={
              elementsLength ||
              _.keys(unitPlan).length ||
              _.keys(resourceItem).length
            }
            onDeleteClick={showWarningModal}
            showCountAlways={true}
            onTagLearningGoalClick={onTagLearningGoalClick}
            updatePost={updatePost}
            showTagLearningGoalsModal={showTagLearningGoalsModal}
            isRecentPost={isRecentPost}
            postsWithGoals={postsWithGoals}
            goToStep={goToStep}
            isArchivedClass={isArchivedClass}
            isCurrentAcademicYearSelected={isCurrentAcademicYearSelected}
            tagTypeStyle={
              !isCurrentAcademicYearSelected
                ? styles.tagTypePreviousYearStyle
                : null
            }
            disabled={disableTagLearningGoals}
            isDeleteDisabled={isDeleteDisabled}
            isAIResponseGenerating={isAIResponseGenerating}
            isPromptBoxContentPresent={isPromptBoxContentPresent}
            isPromptBoxTextPresent={isPromptBoxTextPresent}
            userType={userType}
            testId={"journal-postcreation-taglearninggoals"}
          />
        </ConditionalWrapper>
      </div>
    );
  }
}

const TagStudents = React.memo(props => {
  const {
    postDetails: {
      students: { edges: students = [] } = {},
      isAddAllResponsesToJournal,
      isPrivate = true,
      isHiddenFromStudents = true,
    } = {},
    t,
    goToStep,
    toggleAlert,
    isAIResponseGenerating,
    isPromptBoxContentPresent,
    userType,
    isPromptBoxTextPresent,
  } = props;

  const taggedStudentsCount = _.get(students, "length", 0);
  const isSharedWithEnabled =
    taggedStudentsCount > 0 || isAddAllResponsesToJournal;

  const onShareWithClick = () => {
    if (
      isPortfolioAIEnabledAndIsJournalRoute(userType) &&
      (isAIResponseGenerating ||
        isPromptBoxContentPresent ||
        isPromptBoxTextPresent)
    ) {
      return;
    }
    if (isSharedWithEnabled) {
      goToStep("SHARE_WITH");
    } else {
      toggleAlert({
        showAlert: true,
        alertMessage: t("journal:shared_with_alert_msg"),
      });
    }
  };

  return (
    <div
      className={classes.shareWithOption}
      onClick={onShareWithClick}
      data-test-id={"journal-postcreation-sharewith"}
    >
      <div
        className={classes.innerContainer}
        style={{ opacity: isSharedWithEnabled ? 1 : 0.5 }}
      >
        <TeacherShareOutlined size={"xx-small"} />
        <div
          style={{
            justifyContent: "space-between",
            cursor: isSharedWithEnabled ? "pointer" : "not-allowed",
          }}
          className={classes.tagTypeContainer}
        >
          <div className={classes.tagTypeText}>{t("journal:shared_with")}</div>
          <div className={classes.tagSubTextContainer}>
            <div className={classes.tagSubText}>
              {getSharedWithString({
                isPrivate,
                isHiddenFromStudents,
                withPrefix: false,
                t,
              })}
            </div>
            <div className={classes.privateCheckBoxContainer}>
              <IconButton
                icon={<ChevronRightOutlined size={"xx-small"} />}
                variant={"plain"}
                size={"medium"}
                disabled={!isSharedWithEnabled}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

TagStudents.displayName = "TagStudents";

const FolderTags = React.memo(props => {
  const {
    folders,
    addedFolders,
    removedFolders,
    onAddOrEditClick,
    t,
    isAIResponseGenerating,
    isPromptBoxContentPresent,
    userType,
    isPromptBoxTextPresent,
  } = props;

  const generateFolders = () => {
    let selectedFolders = [];

    //if new then don't do any add remove

    //if update then do add remove on folders and setState selectedFolders

    const selectedFoldersCopy = _.cloneDeep(folders) || BLANK_ARRAY;
    const addedFoldersCopy = _.cloneDeep(addedFolders) || BLANK_ARRAY;

    selectedFolders = _.uniqWith(
      [...selectedFoldersCopy, ...addedFoldersCopy],
      _.isEqual
    );

    _.remove(selectedFolders, folder => {
      return !!_.find(removedFolders, { id: folder.id });
    });
    return selectedFolders;
  };

  const selectedFolders = generateFolders();

  return (
    <div className={classes.tagOption}>
      <TagType
        title={t("journal:tag_folders")}
        dataLength={_.get(selectedFolders, "length", 0)}
        onAddOrEditClick={onAddOrEditClick}
        icon={<FolderOutlined size={"xx-small"} />}
        expandedContent={
          !_.isEmpty(selectedFolders) && (
            <TaggedFolders
              folders={selectedFolders}
              showFolderIcon={true}
            ></TaggedFolders>
          )
        }
        count={
          _.size(selectedFolders) > 0 &&
          t("common:folder_count", { count: _.size(selectedFolders) })
        }
        isAIResponseGenerating={isAIResponseGenerating}
        isPromptBoxContentPresent={isPromptBoxContentPresent}
        isPromptBoxTextPresent={isPromptBoxTextPresent}
        userType={userType}
        testId={"journal-postcreation-tagfolders"}
      />
    </div>
  );
});

FolderTags.displayName = "FolderTags";

const PracticesTagsV2 = React.memo(props => {
  const {
    taggedPractices,
    onAddOrEditClick,
    postTitle,
    t,
    isAIResponseGenerating,
    isPromptBoxContentPresent,
    userType,
    isPromptBoxTextPresent,
  } = props;
  return (
    <div className={classes.tagOption}>
      <TagType
        title={t("common:tag_snp")}
        dataLength={_.size(taggedPractices)}
        onAddOrEditClick={onAddOrEditClick}
        icon={<ScopeAndSequenceOutlined size={"xx-small"} />}
        expandedContent={
          !_.isEmpty(taggedPractices) && (
            <TaggedPracticesV2
              taggedPractices={taggedPractices}
              postTitle={postTitle}
            />
          )
        }
        count={
          !_.isEmpty(taggedPractices) &&
          t("journal:count_practice", {
            count: _.get(taggedPractices[0], "taggedPractice.length"),
          })
        }
        isAIResponseGenerating={isAIResponseGenerating}
        isPromptBoxContentPresent={isPromptBoxContentPresent}
        userType={userType}
        isPromptBoxTextPresent={isPromptBoxTextPresent}
        testId={"journal-postcreation-tagsnp"}
      />
    </div>
  );
});

PracticesTagsV2.displayName = "PracticeTagsV2";

const RateonLearningGoals = React.memo(props => {
  const {
    disabled = false,
    toggleAlert,
    openRatingEditor,
    postRatingsOfLearningGoals,
    studentsCount,
    learningGoalsCount,
    t,
    isDisabledInMyp,
    isAIResponseGenerating,
    isPromptBoxContentPresent,
    userType,
    isPromptBoxTextPresent,
  } = props;
  const onOptionClick = () => {
    if (disabled) {
      let alertMessage = t("journal:tag_student_and_rating_alert_msg");

      if (studentsCount > 0 && learningGoalsCount == 0)
        alertMessage = t("journal:tag_goals_alert_msg");
      else if (learningGoalsCount > 0 && studentsCount == 0)
        alertMessage = t("journal:tag_student_alert_msg");
      else if (isDisabledInMyp)
        alertMessage = t(
          "toastMsgs:rating_only_available_for_atl_and_standards"
        );

      toggleAlert({
        showAlert: true,
        alertMessage: alertMessage,
      });
      return;
    }
    openRatingEditor();
  };

  const onMediaCardClick = e => {
    if (_.has(props, "setShowPostRatingModal"))
      props.setShowPostRatingModal(true);
  };
  return (
    <div className={classes.tagOption}>
      <TagType
        {...props}
        icon={<AssessmentApplicableOutlined disabled={disabled} />}
        title={t("common:rate_on_learning_goals")}
        showTaggedItems={false}
        onAddOrEditClick={onOptionClick}
        expandedContent={
          !_.isEmpty(postRatingsOfLearningGoals) && (
            <MediaCard
              cardType="medium"
              type={"LEARNING GOALS"}
              name={t("common:teacher_evaluation")}
              showSubtext={true}
              onClick={onMediaCardClick}
            />
          )
        }
        isAIResponseGenerating={isAIResponseGenerating}
        isPromptBoxContentPresent={isPromptBoxContentPresent}
        isPromptBoxTextPresent={isPromptBoxTextPresent}
        userType={userType}
        testId={"journal-postcreation-ratelearninggoals"}
      />
    </div>
  );
});

RateonLearningGoals.displayName = "RateonLearningGoals";

class AddPostDetails extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showMediaModal: false,
      showTagModal: false,
      tagModalType: null,
      tagModalStepIndex: 0,
      showFullScreenLoader: false,
      textAreaTitle: null,
      noteTitle: null,
      showAlert: false,
      alertMessage: "",
      showLearningGoalsEditor: false,
      showPostRatingsModal: false,
      showGoalsRemovalWarningModal: false,
      showPostScheduleModal: false,
      scheduleDateTimeDetails: {},
      activeAttachmentIndex: 0,
      isRecording: false,
      showPromptBox: false,
      showPromptBoxOverOptions: false,
      isFocussedRef: false,
      isImageUploading: false,
    };
    const { screenPanelProps: { postDetails } = {} } = this.props;
    // this audioContainerRef is used for styling of audioRecorderSelector
    this.audioContainerRef = createRef(null);
    this.aiInputRef = createRef(null);
    this.containerRef = createRef(null);
    this.textInputRef = null;
    this.contentEditableRef = React.createRef();
    const { attachments } = postDetails;
    const type = _.get(_.first(attachments), "type", "");
    this.isOnlyAudio = type === "AUDIO" && attachments.length === 1;
    this.isNote = type == "NOTE";

    this.updateTextAreaInputDebounce = _.debounce(
      this.updateTextAreaInputReduxState,
      1000
    );
    this.updateNoteTextDebounce = _.debounce(this.updateNote, 1000);
    this.textAreaInputRef = null;
  }

  componentDidMount() {
    const { disableGlobalHeader } = this.props;
    disableGlobalHeader();
    const textAreaTitle = _.get(this, "props.textAreaTitle", "");
    const attachments = _.get(
      this,
      "props.screenPanelProps.postDetails.attachments",
      BLANK_ARRAY
    );
    const noteTitle = _.get(attachments[0], "title", "");

    const newState = {
      textAreaTitle: textAreaTitle,
      noteTitle: noteTitle,
    };

    const newReduxState = {};
    const {
      screenPanelProps: { updatePost, postServerObject, mode } = {},
      currentActiveTerm,
      userType,
    } = this.props;
    if (
      !_.isEmpty(_.get(this.props, "courseUnitPlans", BLANK_ARRAY)) &&
      this.props.isData
    )
      newReduxState.courseUnitPlans = _.get(
        this.props,
        "courseUnitPlans",
        BLANK_ARRAY
      );

    newReduxState.academicTerm = { id: currentActiveTerm?.key };

    if (
      mode === "edit" &&
      _.get(postServerObject, "state") === "SCHEDULED" &&
      userType === "staff"
    ) {
      newState.scheduleDateTimeDetails = {
        date: moment(_.get(postServerObject, "publishedAt")),
        time: moment(_.get(postServerObject, "publishedAt")),
      };
    }
    this.setState(newState);
    if (!_.isEmpty(newReduxState)) updatePost(newReduxState);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      screenPanelProps: { updatePost } = {},
      currentActiveTerm,
      disableGlobalHeader,
    } = this.props;
    const { showMediaModal } = this.state;
    if (
      !_.isEmpty(_.get(this.props, "courseUnitPlans", BLANK_ARRAY)) &&
      _.size(
        _.differenceBy(
          _.get(this.props, "courseUnitPlans", BLANK_ARRAY),
          _.get(prevProps, "courseUnitPlans", BLANK_ARRAY),
          "id"
        ),
        0
      )
    )
      updatePost({
        courseUnitPlans: _.get(this.props, "courseUnitPlans", BLANK_ARRAY),
      });

    if (
      _.get(prevProps, "currentActiveTerm.key") !=
      _.get(currentActiveTerm, "key")
    )
      updatePost({ academicTerm: { id: currentActiveTerm?.key } });

    if (!showMediaModal) {
      disableGlobalHeader();
    }
  }

  componentWillUnmount() {
    const { enableGlobalHeader, screenPanelProps } = this.props;
    const { parentType } = screenPanelProps;
    isGlobalHeaderOnMultipleScreensEnabled() &&
      (parentType === "POST" || _.isUndefined(parentType)) &&
      enableGlobalHeader();
    this.updateTextAreaInputDebounce.cancel();
    this.updateNoteTextDebounce.cancel();
  }

  toggleMediaModal = value => {
    this.setState({
      showMediaModal: value,
      currentAttachmentIndex: 0,
    });
  };

  toggleMediaModalWithIndex = ({ value, attachmentIndex = 0 }) => {
    this.setState({
      showMediaModal: value,
      currentAttachmentIndex: attachmentIndex,
    });
  };

  onMediaClick = ({ value, attachmentIndex = 0 }) => {
    if (showNewTheatreMode()) {
      this.toggleMediaModalWithIndex({ value, attachmentIndex });
    } else {
      this.toggleMediaModal(value);
    }
  };

  updateAudioAttachments = params => {
    const { screenPanelProps: { updatePost, postDetails } = {} } = this.props;
    const attachments = _.get(postDetails, "attachments", BLANK_ARRAY);
    const newAudioAttachment = { ...params };
    this.setState({ isRecording: false });
    updatePost({
      attachments: [
        ...attachments,
        _.omit(newAudioAttachment, [
          "__typename",
          "id",
          "name",
          "thumbUrl",
          "title",
        ]),
      ],
    });
  };

  updateTextAreaInputLocally = async ({ title = "" }) => {
    const { userType } = this.props;
    let updatedTitle = title;
    if (isPortfolioAIEnabledAndIsJournalRoute(userType)) {
      updatedTitle = cleanupMessage({
        message: title,
      });
    }
    this.setState({
      textAreaTitle: updatedTitle,
    });
    this.updateTextAreaInputDebounce();
  };

  updateTextAreaInputReduxState = async () => {
    const { updatePost } = this.props;
    updatePost({ title: this.state.textAreaTitle });
  };

  updateNoteTextLocally = params => {
    const { userType } = this.props;
    let updatedTitle = _.get(params, "title", "");
    if (isPortfolioAIEnabledAndIsJournalRoute(userType)) {
      updatedTitle = cleanupMessage({
        message: _.get(params, "title", ""),
      });
    }
    this.setState({
      noteTitle: updatedTitle,
    });
    this.updateNoteTextDebounce(params);
  };

  updateNote = params => {
    const { screenPanelProps: { updatePost, postDetails } = {} } = this.props;
    const attachment = _.get(postDetails, "attachments[0]", BLANK_OBJECT);

    updatePost({ attachments: [{ ...attachment, ...params }] });
  };

  toggleIsPrivate = () => {
    const {
      screenPanelProps: { updatePost, postDetails: { isPrivate = false } } = {},
    } = this.props;
    updatePost({ isPrivate: !isPrivate });
  };

  goToStep = step => {
    this.setState({
      showTagModal: true,
      tagModalType: step,
      showAlert: false,
      alertMessage: "",
      tagModalStepIndex: 0,
    });
  };

  goToStepWithIndex = (step, index) => {
    this.setState({
      showTagModal: true,
      tagModalType: step,
      showAlert: false,
      alertMessage: "",
      tagModalStepIndex: index,
    });
  };

  onCloseTagModal = () => {
    const { tagModalType = "" } = this.state;
    if (
      tagModalType == TAG_FROM_ALL_LEARNING_GOALS ||
      tagModalType == TAG_LEARNING_GOALS_FROM_UNIT ||
      tagModalType == TAG_LEARNING_GOALS_FROM_ASSESSMENTS ||
      tagModalType == "TAG_PYP_ELEMENT" ||
      tagModalType == "TAG_LEARNING_GOALS_FROM_POST"
    ) {
      const { screenPanelProps: { updatePost, postDetails } = {} } = this.props;
      updatePost({
        unitPlan: _.get(postDetails, "originalUnitPlan", undefined),
        isResourceSkipped: _.get(
          postDetails,
          "originalIsResourceSkipped",
          false
        ),
        resourceId: _.get(postDetails, "originalResourceId", undefined),
        resourceType: _.get(postDetails, "originalResourceType", undefined),
        resourceItem: _.get(postDetails, "originalResourceItem", undefined),
        elementPYP: _.get(postDetails, "originalElementPYP", undefined),
        selectFromAllPYP: _.get(postDetails, "originalSelectFromAllPYP", false),
      });
    }
    this.setState({ showTagModal: false, tagModalType: null });
  };

  onDoneClick = () => {
    this.setState({ showTagModal: false, tagModalType: null });
  };

  onDeleteAudioAttachment = () => {
    const { screenPanelProps: { updatePost, postDetails } = {} } = this.props;
    const attachments = _.get(postDetails, "attachments", BLANK_ARRAY);
    const filteredAttachments = _.filter(
      attachments,
      attachment => attachment.type !== "AUDIO"
    );
    updatePost({ attachments: [...filteredAttachments] });
  };

  syncLocalStateWithRedux = (title, reduxNoteTitle) => {
    const { textAreaTitle, noteTitle } = this.state;
    const { updatePost } = this.props;
    if (!_.isNull(textAreaTitle) && !_.isEqual(title, textAreaTitle)) {
      if (this.updateTextAreaInputDebounce.cancel) {
        this.updateTextAreaInputDebounce.cancel();
      }
      updatePost({ title: textAreaTitle });
    }

    if (!_.isNull(noteTitle) && !_.isEqual(noteTitle, reduxNoteTitle)) {
      if (this.updateNoteTextDebounce.cancel) {
        this.updateNoteTextDebounce.cancel();
      }
      this.updateNote({ title: noteTitle });
    }
  };

  getStudents = students => {
    return _.map(students, student => {
      return {
        name: `${_.get(student, "firstName")} ${_.get(student, "lastName")}`,
      };
    });
  };

  getPlaceholder = () => {
    const { t, screenPanelProps: { postDetails } = {} } = this.props;
    const { isAddAllResponsesToJournal, customPlaceHolder } = postDetails;
    if (customPlaceHolder) {
      return t(customPlaceHolder);
    } else if (isAddAllResponsesToJournal) {
      return t("journal:write_common_caption_anectode_for_all_responses");
    } else {
      return t("journal:edit_post_placeholder_textarea");
    }
  };

  setShowPostRatingModal = value => {
    this.setState({ showPostRatingsModal: value });
  };

  togglePostScheduleModal = value => {
    this.setState({
      showPostScheduleModal: value,
    });
  };

  onConfirmDateChange = ({ date, time }) => {
    const { updatePost, screenPanelProps = {} } = this.props;
    const { onPublishClick, mode = "create" } = screenPanelProps;
    if (
      !_.isNil(date) &&
      !_.isEmpty(date) &&
      !_.isNil(time) &&
      !_.isEmpty(time)
    ) {
      this.setState({
        scheduleDateTimeDetails: { date, time },
        showPostScheduleModal: false,
      });
      updatePost({
        publishedAt: moment(
          date.format("YYYY-MM-DD") + " " + time.format("HH:mm")
        ),
      });
    }
  };

  onCloseSchedulePostModal = () => {
    this.setState({
      showPostScheduleModal: false,
    });
  };

  setShowPromptBox = value => {
    this.setState({
      showPromptBox: value,
    });
  };

  setShowPromptBoxOverOptions = value => {
    this.setState({
      showPromptBoxOverOptions: value,
    });
  };

  setTextAreaTitle = async (value, callback) => {
    this.setState(
      {
        textAreaTitle: cleanupMessage({ message: value }),
      },
      () => {
        callback && callback();
      }
    );
  };

  setNoteTitle = async (value, callback) => {
    this.setState(
      {
        noteTitle: cleanupMessage({ message: value }),
      },
      () => {
        callback && callback();
      }
    );
  };

  handleSelect = e => {
    const { userType } = this.props;
    if (
      isPortfolioAIEnabledAndIsJournalRoute(userType) &&
      e.target === this.textInputRef?.domElm
    ) {
      this.aiInputRef?.current?.handleTextSelection(e);
    }
  };

  getTextAreaTitle = () => {
    return this.state.textAreaTitle;
  };

  getNoteTitle = () => {
    return this.state.noteTitle;
  };

  setTextInputRef = ref => {
    this.textInputRef = ref;
  };

  setImageUpload = value => {
    this.setState({ isImageUploading: value });
  };

  getIsImageUploading = () => {
    return this.state.isImageUploading;
  };

  render() {
    const {
      screenPanelProps = BLANK_OBJECT,

      elementData,
      selectFromAllPYP,
      isLoading,
      isData,
      showTagSnpV2,
      t,
      userType,
      showTagPYPElements,
      showTagStudents,
      showTagFolder,
      isApprovalRequiredForStudentPosts,
      taggableElements,
      isCurrentAcademicYearSelected,
      isArchivedClass,
      toolResponses,
      ibPYPElementRatings,
      isUploading,
      showRateonLearingGoals,
      postRatingsOfLearningGoals,
      originalibPYPElementRatings,
      curriculumProgramType,
      canScheduleAPost = false,
      setToastMsg,
      currentActiveTerms,
      currentActiveTerm,
      isRecentPost,
      postsWithGoals = [],
      gradeId,
      curriculumProgramId,
      postType = "",
      setGlobalTrayEnabledState,
      isAIResponseGenerating,
      isPromptBoxContentPresent,
      isPromptBoxTextPresent,
      defaultStudentIdentifierNamePreference,
    } = this.props;

    const {
      REGENERATE,
      SHORTEN,
      ELABORATE,
      SIMPLIFY_LANGUAGE,
      FIX_SPELLING_GRAMMAR,
      IMPROVE_LANGUAGE,
      AUTOGENERATE_CAPTION,
      ASK_AI_WITHOUT_IMAGE,
      ASK_AI_ATTACHMENT_CAPTION,
      ASK_AI_ATTACHMENT_CAPTION_FILLED,
    } = aiGenerateActionsMapping;

    const {
      postDetails: {
        title,
        students: { edges: students = [] } = {},
        attachments = [],
        elementPYP = [],
        unitPlan,
        resourceItem,
        resourceType,
        state,
        addedFolders,
        removedFolders,
        taggedPractices,
        folders,
        isAddLEToJournal,
        isAddStudentAttachmentToJournal = false,
        isAddAllResponsesToJournal,
        items,
        studentsWithResponsePendingToPublish,
        ibPYPElementRatings: postPypElementRatings,
        isResourceSkipped,
        publishedAt = "",
        createdAt,
        showTagLearningGoalsModal,
      } = {},
      onPublishClick,
      onDraftClick,
      onMediaCreate,
      onSendForApprovalClick,
      onAddAllResponsesToJournal,
      mode,
      mediaCreationOptions,
      setWorkbookMode,
      totalNewSnpCycles,
      onCloseClick,
      updatePost,
      postServerObject,
      goToStep,
    } = screenPanelProps;

    const responseData = _.find(
      items,
      item => _.get(item, "itemType", "") === "STUDENT_ASSIGNMENT"
    );
    const item = _.get(responseData, "item", BLANK_OBJECT);
    const unitPlanFields = _.get(unitPlan, "allFields", BLANK_ARRAY);
    const itemToolResponses = _.get(item, "toolResponses", BLANK_OBJECT);
    const itemIbPYPElementRatings = _.get(
      item,
      "ibPYPElementRatings",
      BLANK_ARRAY
    );

    const isResponseEmpty = _.isEmpty(_.get(item, "submission.response"));
    const isAttachmentGroupEmpty = _.isEmpty(
      _.get(item, "submission.attachmentGroups")
    );

    //To handle non post media creation
    const { enableTagging, enableCaption } = mediaCreationOptions;

    const attachmentType = _.get(attachments[0], "type", "");
    const reduxNoteTitle = _.get(attachments[0], "title", "");
    const showCaptionTextArea =
      (attachmentType != "NOTE" && enableCaption) || isAddLEToJournal;
    const showMediaPlaceholder = attachmentType != "NOTE";
    const showAudioRecorder =
      ["IMAGE", "LINK", "FILE", "WORKBOOK", "VIDEO"].includes(attachmentType) ||
      isAddLEToJournal;

    //hide edit workbook feature when adding from portfolio
    const showEditWorkbookIcon =
      !!_.get(attachments[0], "metadata.workbookUrl", "") &&
      _.get(attachments[0], "type", "") !== "IMAGE" &&
      !isAddStudentAttachmentToJournal;
    const pendingStudentsCount = _.size(studentsWithResponsePendingToPublish);

    const tooltipComponentClass = classnames({
      [classes.hoverState]: pendingStudentsCount > 2,
      [classes.nonHoverState]: pendingStudentsCount === 2,
    });

    const basicDetailContainerClass = classnames({
      [classes.basicDetailContainer]: true,
      [classes.basicDetailWithStudentResponse]:
        isAddLEToJournal || isAddAllResponsesToJournal,
    });

    const isPostTypeImage = postType === "PHOTO";
    const isPostTypeVoice = postType === "VOICE";
    const comp = (
      <div className={tooltipComponentClass}>
        {pendingStudentsCount === 2
          ? `${_.get(
              this.getStudents(studentsWithResponsePendingToPublish)[0],
              "name"
            )} and ${_.get(
              this.getStudents(studentsWithResponsePendingToPublish)[1],
              "name"
            )}`
          : `${_.get(
              this.getStudents(studentsWithResponsePendingToPublish)[0],
              "name"
            )} and ${pendingStudentsCount - 1} ${t("snp:others")}`}
      </div>
    );

    const toggleAlert = ({ showAlert = false, alertMessage = "" }) => {
      this.setState({
        showAlert: showAlert,
        alertMessage: alertMessage,
      });
    };

    const isDisabledInMyp =
      curriculumProgramType === CURRICULUM_TYPE_MYP &&
      !_.some(
        elementPYP,
        element =>
          _.includes(["atlsMYP", "learningStandardMYP"], element.fieldUID) &&
          !_.isEmpty(element.value)
      );

    const {
      showMediaModal,
      showTagModal,
      tagModalType,
      tagModalStepIndex,
      showFullScreenLoader,
      textAreaTitle,
      noteTitle,
      showAlert,
      alertMessage,
      showGoalsRemovalWarningModal,
      isRecording,
      showPromptBox,
      showPromptBoxOverOptions,
    } = this.state;

    const learningGoalsCount = _.reduce(
      elementPYP,
      (acc, goal) => {
        return acc + goal.value.length;
      },
      0
    );

    const onEditLearningGoals = () => {
      updatePost({
        originalUnitPlan: unitPlan,
        originalIsResourceSkipped: isResourceSkipped,
        originalResourceId: resourceItem?.id,
        originalResourceType: resourceItem?.type,
        originalResourceItem: resourceItem,
        originalElementPYP: elementPYP,
        originalSelectFromAllPYP: selectFromAllPYP,
        selectFromAllPYP: selectFromAllPYP, // During edit post, selectFromAllPYP might be undefined. so set before opening the modal
      });

      if (selectFromAllPYP) {
        this.goToStep(TAG_FROM_ALL_LEARNING_GOALS);
      } else if (!_.isNil(unitPlan) && _.isNil(resourceItem)) {
        this.goToStepWithIndex(TAG_LEARNING_GOALS_FROM_UNIT, 1);
      } else if (!_.isNil(unitPlan) && !_.isNil(resourceItem)) {
        this.goToStepWithIndex(TAG_LEARNING_GOALS_FROM_ASSESSMENTS, 1);
      } else {
        this.goToStepWithIndex(TAG_LEARNING_GOALS_FROM_POST, 1);
      }
    };

    const onAddOrEditClickOfPYPElementTag = () => {
      onEditLearningGoals();
      this.goToStepWithIndex("TAG_PYP_ELEMENT", 2);
    };
    const onCloseGoalsRemovalWarningModal = () =>
      this.setState({ showGoalsRemovalWarningModal: false });

    const onConfirmRemovalOfGoals = () => {
      updatePost({
        // clear main properties of learning goals
        unitPlan: null,
        isResourceSkipped: false,
        resourceId: null,
        resourceType: null,
        resourceItem: undefined,
        elementPYP: undefined,
        // Clear properties used for backup
        originalUnitPlan: null,
        originalIsResourceSkipped: false,
        originalResourceId: null,
        originalResourceType: null,
        originalResourceItem: undefined,
        originalElementPYP: undefined,
        selectFromAllPYP: undefined,
        // clear ratings as well
        ibPYPElementRatings: [],
        originalibPYPElementRatings: [],
        showTagLearningGoalsModal: false,
      });
      this.setState({ showGoalsRemovalWarningModal: false });
    };

    const NoGradesConfiguredModal = props => {
      const { onClose } = props;
      return (
        <Modal width="100%" height="100%" isOpen={true} onClose={onClose}>
          <Modal.Header title={t("common:rate_on_learning_goals")} isClosable />
          <Modal.Body style={styles.noGradesConfiguredModalHeader}>
            <div className={classes.noGradesConfiguredModal}>
              <EmptyState
                illustration={NoChecklistIllustration}
                title={t("journal:no_grades_configured")}
                subtitle={t("journal:no_grades_configured_subtext")}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="outlined-subtle"
              size={"large"}
              onClick={onClose}
              style={styles.noGradesConfiguredModalCancelStyle}
            >
              {t("common:cancel")}
            </Button>
          </Modal.Footer>
        </Modal>
      );
    };

    const isPortfolioAI = isPortfolioAIEnabledAndIsJournalRoute(userType);
    const audioAttachmentLength = getAttachmentsByTypeFromAttachmentArr({
      attachmentsArr: attachments,
      type: "AUDIO",
    })?.length;

    const isPostOfImageType = () => {
      const audioAttachments = _.filter(
        attachments,
        attachment => attachment.type === "AUDIO"
      );
      if (_.size(audioAttachments) > 1) {
        return false;
      }
      const validAttachments = _.some(
        attachments,
        attachment => attachment.type === "IMAGE"
      );
      return showAudioRecorder && validAttachments && _.isEqual(mode, "edit");
    };
    const isImageTypePost = isPostOfImageType() || isPostTypeImage;

    const onChangeTextAreaInput = e => {
      this.updateTextAreaInputLocally({
        title: e?.target?.value,
      });
    };
    return (
      <React.Fragment>
        {showFullScreenLoader && <FullScreenLoader />}
        {/* Warning modal, visible when user want to delete tagged learning goals */}
        {showGoalsRemovalWarningModal && (
          <UIModal
            isOpen={showGoalsRemovalWarningModal}
            modalContent={classes.warningModalContainer}
            onRequestClose={onCloseGoalsRemovalWarningModal}
          >
            <div className={classes.warningModalInnerContainer}>
              <div className={classes.warningModalHeader}>
                {t("journal:remove_tagged_learning_goals")}
                <IconButton
                  icon={<CloseOutlined />}
                  onClick={onCloseGoalsRemovalWarningModal}
                  variant={"plain"}
                />
              </div>
              <div className={classes.warningModalBody}>
                {t("journal:remove_learning_goals_warning_count", {
                  count: learningGoalsCount,
                })}
              </div>
              <div className={classes.warningModalFooter}>
                <Button
                  size="large"
                  variant="outlined-subtle"
                  onClick={onCloseGoalsRemovalWarningModal}
                  style={{ marginRight: "12px" }}
                >
                  {t("common:keep")}
                </Button>
                <Button
                  size="large"
                  variant="destructive"
                  onClick={onConfirmRemovalOfGoals}
                >
                  {t("common:remove")}
                </Button>
              </div>
            </div>
          </UIModal>
        )}
        <ScreenPanel
          {...screenPanelProps}
          footerComponent={
            <FooterComponent
              t={t}
              {...mediaCreationOptions}
              onMediaCreate={onMediaCreate}
              onPublishClick={onPublishClick}
              onDraftClick={onDraftClick}
              isAddAllResponsesToJournal={isAddAllResponsesToJournal}
              onAddAllResponsesToJournal={onAddAllResponsesToJournal}
              state={state}
              mode={mode}
              userType={userType}
              onSendForApprovalClick={onSendForApprovalClick}
              isApprovalRequiredForStudentPosts={
                isApprovalRequiredForStudentPosts
              }
              onCloseClick={onCloseClick}
              togglePostScheduleModal={this.togglePostScheduleModal}
              setScheduleDateTimeDetails={details =>
                this.setState({ scheduleDateTimeDetails: details })
              }
              canScheduleAPost={canScheduleAPost}
              publishedAt={publishedAt}
              createdAt={createdAt}
              scheduleDateTimeDetails={this.state.scheduleDateTimeDetails}
              updatePost={updatePost}
              postServerObject={postServerObject}
              postDetails={_.get(screenPanelProps, "postDetails", BLANK_OBJECT)}
              setToastMsg={setToastMsg}
              noteTitle={this.state.noteTitle}
              isNote={this.isNote}
              isPostTypeImage={isPortfolioAI && isImageTypePost}
              isImageUploading={this.state.isImageUploading}
              isAIResponseGenerating={isAIResponseGenerating}
              isPromptBoxContentPresent={isPromptBoxContentPresent}
              isPromptBoxTextPresent={isPromptBoxTextPresent}
              curriculumProgramType={curriculumProgramType}
            />
          }
          parentContainerRef={this.containerRef}
        >
          <div className={classes.container}>
            {showAlert && (
              <div className={classes.alertContainer}>
                <Alert
                  type={"warning"}
                  isClosable={true}
                  title={alertMessage}
                  onClose={toggleAlert}
                  style={{
                    boxShadow: ` 1px 1px 4px 0px rgba(0, 46, 57, 0.15)`,
                  }}
                />
              </div>
            )}
            <div className={basicDetailContainerClass}>
              {isAddAllResponsesToJournal && (
                <div className={classes.addAllResponsesToJournalContainer}>
                  <Trans
                    i18nKey={
                      "journal:responses_will_be_added_with_following_details"
                    }
                  >
                    Responses of
                    <Tooltip
                      data={this.getStudents(
                        studentsWithResponsePendingToPublish
                      )}
                      length={1}
                      tooltipPlacement="bottom"
                      moreJoinSymbol={`and `}
                      keyToMap="name"
                      label={t("common:students")}
                      trigger={pendingStudentsCount > 2 ? ["hover"] : [null]}
                      renderComponent={comp}
                    />
                    will be added to journal with following details:
                  </Trans>
                </div>
              )}
              {showCaptionTextArea && (
                <div
                  className={classes.captionContainer}
                  onSelect={this.handleSelect}
                  style={{
                    position: isPortfolioAI ? "relative" : "",
                    minHeight: isPortfolioAI ? "200px" : "",
                    display: isPortfolioAI ? "grid" : "",
                    gridTemplateRows: isPortfolioAI ? "1fr auto" : "",
                    border: isAddAllResponsesToJournal ? "none" : "",
                  }}
                >
                  {isAddAllResponsesToJournal ? (
                    <DSTextAreaInput
                      name={"title"}
                      placeholder={this.getPlaceholder()}
                      value={textAreaTitle}
                      onChange={onChangeTextAreaInput}
                      minRows={5}
                      onBlur={() =>
                        this.syncLocalStateWithRedux(title, reduxNoteTitle)
                      }
                      ref={ref => (this.textAreaInputRef = ref)}
                    />
                  ) : null}
                  {!isPortfolioAI && !isAddAllResponsesToJournal ? (
                    <TextAreaInput
                      name={"title"}
                      value={textAreaTitle}
                      minRows={5}
                      placeholder={this.getPlaceholder()}
                      updateInputField={this.updateTextAreaInputLocally}
                      onBlur={() =>
                        this.syncLocalStateWithRedux(title, reduxNoteTitle)
                      }
                      ref={ref => (this.textAreaInputRef = ref)}
                      textAreaStyles={{
                        border: "none",
                      }}
                      autoFocus={true}
                    />
                  ) : null}
                  {isPortfolioAI ? (
                    <div style={{ minHeigh: "132px" }}>
                      <UIBaseContentEditable
                        value={textAreaTitle}
                        style={{
                          ...styles.textArea,
                        }}
                        ref={ref => (this.textInputRef = ref)}
                        mode={mode}
                        placeholder={
                          isWindows()
                            ? t("journal:placeholder_for_ai_caption_windows")
                            : t("journal:placeholder_for_ai_caption")
                        }
                        onFocusInputField={() => {
                          this.textInputRef.focus();
                          this.setState({ isFocussedRef: true });
                        }}
                        onBlurInputField={() => {
                          this.syncLocalStateWithRedux(title, reduxNoteTitle);
                          setTimeout(() => {
                            this.setState({ isFocussedRef: false });
                          }, 300);
                        }}
                        updateInputField={this.updateTextAreaInputLocally}
                        updateInputRef={ref =>
                          (this.contentEditableRef.current = ref)
                        }
                        id="text-area-input"
                        name={"title"}
                        shouldParseInPlainText={false}
                        onKeyDown={event => {
                          if (
                            (event.metaKey || event.ctrlKey) &&
                            event.key === "j"
                          ) {
                            event.preventDefault(); // Prevent the default behavior of the key combination
                            // Perform your custom logic here
                            this.setState({
                              showPromptBoxOverOptions: true,
                              showPromptBox: true,
                            });
                            this.aiInputRef?.current?.setDisplayOptionsDefault();
                          }
                        }}
                        shouldPasteAsPlainText={true}
                        styleStripType={"CONTENT_EDITABLE"}
                        editContainerStyle={{
                          height: "fit-content",
                          minHeight: "24px",
                        }}
                        containerStyle={{
                          height: "fit-content",
                          minHeight: "24px",
                        }}
                        testId={"journal-postcreation-textarea"}
                      />
                    </div>
                  ) : null}
                  {showAudioRecorder &&
                  getAttachmentsByTypeFromAttachmentArr({
                    attachmentsArr: attachments,
                    type: "AUDIO",
                  }).length == 0 &&
                  !isPortfolioAI ? (
                    <div
                      ref={this.audioContainerRef}
                      style={{
                        width: isRecording ? "100%" : "",
                        height: "58px",
                      }}
                    >
                      <AudioRecorderSelector
                        showValue={false}
                        updateInputField={this.updateAudioAttachments}
                        buttonComponent={
                          <div>
                            <IconButton
                              variant="plain"
                              size={"large"}
                              icon={<MicrophoneOutlined />}
                              disabled={isUploading}
                            />
                          </div>
                        }
                        buttonContainerStyle={{
                          display: "flex",
                          flexFlow: "row-reverse",
                          paddingRight: "16px",
                          height: "58px",
                          alignItems: "center",
                        }}
                        version={"v2"}
                        container={this.audioContainerRef}
                        disabled={isUploading}
                      />
                    </div>
                  ) : null}
                  {/*
                    if this.isOnlyAudio is true, then display it in MediaPlaceholder
                    else display it in attachmentList inside text input box
                  */}
                  {this.isOnlyAudio && !isAddLEToJournal ? null : (
                    <AttachmentList
                      value={getAttachmentsByTypeFromAttachmentArr({
                        attachmentsArr: attachments,
                        type: "AUDIO",
                      })}
                      name={"attachments"}
                      cardType={"horizontal"}
                      showCreateDropdown={false}
                      parentId={""}
                      parentType={""}
                      showSingleCardTheme={true}
                      attachmentContainerStyle={{
                        gridTemplateColumns: "unset",
                        marginBottom: "0px",
                        paddingInline: isPortfolioAI ? "16px" : "",
                      }}
                      onClickAttachmentCard={_.noop}
                      onDeleteAudioAttachment={this.onDeleteAudioAttachment}
                    />
                  )}
                  {isPortfolioAI ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent:
                          isPostTypeVoice || this.isOnlyAudio
                            ? "flex-end"
                            : "space-between",
                        paddingBottom:
                          isPostTypeVoice || this.isOnlyAudio ? "6px" : "",
                        height: !isAIResponseGenerating ? "58px" : " 16px",
                      }}
                    >
                      {showAudioRecorder && !showPromptBox ? (
                        <div
                          ref={this.audioContainerRef}
                          style={{
                            width: isRecording ? "100%" : "",
                            height: isRecording ? "58px" : "",
                            paddingTop: isRecording ? "4px" : "",
                          }}
                        >
                          <AudioRecorderSelector
                            showValue={false}
                            updateInputField={this.updateAudioAttachments}
                            buttonComponent={
                              <div>
                                <IconButton
                                  variant="plain"
                                  size={"small"}
                                  icon={<MicrophoneOutlined />}
                                  disabled={
                                    isUploading || audioAttachmentLength
                                  }
                                  onClick={() => {
                                    audioAttachmentLength == 0 &&
                                      this.setState({ isRecording: true });
                                  }}
                                />
                              </div>
                            }
                            buttonContainerStyle={{
                              display: "flex",
                              flexFlow: "row-reverse",
                              paddingLeft: "8px",
                              height: "58px",
                              alignItems: "center",
                              paddingTop: "2px",
                            }}
                            version={"v2"}
                            container={this.audioContainerRef}
                            disabled={isUploading || audioAttachmentLength}
                            onCancel={() => {
                              this.setState({ isRecording: false });
                            }}
                          />
                        </div>
                      ) : null}

                      {!isRecording ? (
                        <div
                          className={classes.promptBoxContainer}
                          style={{
                            width:
                              showPromptBox || showPromptBoxOverOptions
                                ? "100%"
                                : "",
                            paddingBottom:
                              showPromptBox || showPromptBoxOverOptions
                                ? "0px"
                                : "",
                            position:
                              showPromptBox || showPromptBoxOverOptions
                                ? "absolute"
                                : "",
                            top:
                              showPromptBox || showPromptBoxOverOptions
                                ? "0px"
                                : "",
                          }}
                        >
                          <AIInputBox
                            gradeId={gradeId}
                            showPromptBox={showPromptBox}
                            setShowPromptBox={this.setShowPromptBox}
                            showPromptBoxOverOptions={showPromptBoxOverOptions}
                            setShowPromptBoxOverOptions={
                              this.setShowPromptBoxOverOptions
                            }
                            aiInputRef={this.aiInputRef}
                            textAreaTitle={this.state.textAreaTitle}
                            setTextAreaTitle={this.setTextAreaTitle}
                            updateTextAreaInputLocally={
                              this.updateTextAreaInputLocally
                            }
                            enableChatGPTPoweredTextFeatures={true}
                            isFocussedRef={this.state.isFocussedRef}
                            textInputRef={this.textInputRef}
                            contentEditableRef={this.contentEditableRef}
                            getTextAreaTitle={this.getTextAreaTitle}
                            placeholder={t("journal:describe_post")}
                            isToddleAIDisabled={!_.size(attachments)}
                            curriculumProgramId={curriculumProgramId}
                            setImageUpload={this.setImageUpload}
                            isImageUploading={this.state.isImageUploading}
                            showMagicWand={isImageTypePost}
                            askAIPromptAction={
                              isImageTypePost && !textAreaTitle
                                ? ASK_AI_WITHOUT_IMAGE
                                : textAreaTitle
                                ? ASK_AI_ATTACHMENT_CAPTION_FILLED
                                : ASK_AI_ATTACHMENT_CAPTION
                            }
                            useCustomAIIcon={true}
                            goToStep={goToStep}
                            parentContainerRef={this.containerRef}
                            responseStyle={{ lineHeight: "1.6rem" }}
                          />
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              )}
              {attachmentType == "NOTE" &&
                !isAddLEToJournal &&
                (!isPortfolioAI ? (
                  <Note
                    value={noteTitle}
                    updateNote={this.updateNoteTextLocally}
                    placeholder={t("common:text_placeholder")}
                    noteName={"title"}
                    noteTextAreaStyles={styles.noteTextAreaStyles}
                    onBlur={() =>
                      this.syncLocalStateWithRedux(title, reduxNoteTitle)
                    }
                  />
                ) : (
                  <NoteV2
                    value={noteTitle}
                    updateNote={this.updateNoteTextLocally}
                    placeholder={
                      isWindows()
                        ? t("journal:placeholder_for_ai_caption_note_windows")
                        : t("journal:placeholder_for_ai_caption_note")
                    }
                    noteName={"title"}
                    noteTextAreaStyles={styles.noteTextAreaStyles}
                    onBlur={() => {
                      this.syncLocalStateWithRedux(title, reduxNoteTitle);
                    }}
                    contentEditableRef={this.contentEditableRef}
                    textInputRef={this.textInputRef}
                    updateTextAreaInputLocally={this.updateTextAreaInputLocally}
                    showPromptBox={showPromptBox}
                    setShowPromptBox={this.setShowPromptBox}
                    showPromptBoxOverOptions={showPromptBoxOverOptions}
                    setShowPromptBoxOverOptions={
                      this.setShowPromptBoxOverOptions
                    }
                    getTextAreaTitle={this.getNoteTitle}
                    setTextAreaTitle={this.setNoteTitle}
                    setTextInputRef={this.setTextInputRef}
                    parentContainerRef={this.containerRef}
                    isAIResponseGenerating={isAIResponseGenerating}
                  />
                ))}
              {!!showMediaPlaceholder &&
                !isAddLEToJournal &&
                !isAddAllResponsesToJournal && (
                  <div className={classes.mediaPlaceHolderContainer}>
                    {showEditWorkbookIcon && (
                      <div
                        className={classes.editInWorkbookIconContainer}
                        onClick={() =>
                          this.onMediaClick({ value: true, attachmentIndex: 0 })
                        }
                      >
                        <div
                          onClick={() => setWorkbookMode("USE_TEMPLATE")}
                          className={classes.editInWorkbookIconWrapper}
                        >
                          <EditInWorkbookSvg
                            width={24}
                            height={24}
                            fill={colors.white}
                          />
                        </div>
                      </div>
                    )}
                    {isPortfolioAI && isPostTypeImage ? (
                      !this.state.isImageUploading ? (
                        <MediaPlaceholder
                          attachments={
                            this.isOnlyAudio
                              ? attachments
                              : getAttachmentsByTypeFromAttachmentArr({
                                  attachmentsArr: attachments,
                                  type: "AUDIO",
                                  except: true,
                                })
                          }
                          onClickMedia={({ activeIndex = 0 }) => {
                            this.onMediaClick({
                              value: true,
                              attachmentIndex: activeIndex,
                            });
                          }}
                          showVideoPlayer={true}
                          imageMaxWidth={658}
                          showMiddleContainerIcons={false}
                          showCarouselV2={true}
                          showIconCardsWithExtension={true}
                          showVideoPlayerV2={true}
                        />
                      ) : null
                    ) : (
                      <MediaPlaceholder
                        attachments={
                          this.isOnlyAudio
                            ? attachments
                            : getAttachmentsByTypeFromAttachmentArr({
                                attachmentsArr: attachments,
                                type: "AUDIO",
                                except: true,
                              })
                        }
                        onClickMedia={({ activeIndex = 0 }) => {
                          this.onMediaClick({
                            value: true,
                            attachmentIndex: activeIndex,
                          });
                        }}
                        showVideoPlayer={true}
                        imageMaxWidth={658}
                        showMiddleContainerIcons={false}
                        showCarouselV2={true}
                        showIconCardsWithExtension={true}
                        showVideoPlayerV2={true}
                      />
                    )}
                  </div>
                )}
            </div>
            {isAddLEToJournal && !isAddAllResponsesToJournal && (
              <div style={{ padding: "32px 0" }}>
                <Accordian
                  hideContainerBorder={true}
                  showLabelBorder={false}
                  customTitleComponent={
                    <StudentResponseProfile
                      student={_.get(item, "student", BLANK_OBJECT)}
                      t={t}
                      defaultStudentIdentifierNamePreference={
                        defaultStudentIdentifierNamePreference
                      }
                    />
                  }
                  expandedContent={
                    <div className={classes.studentResponseContainer}>
                      <StudentResponseV2
                        item={{
                          ...item,
                          unitPlanFields: unitPlanFields,
                          toolResponses: !_.isEmpty(itemToolResponses)
                            ? itemToolResponses
                            : toolResponses,
                          ibPYPElementRatings: !_.isEmpty(
                            itemIbPYPElementRatings
                          )
                            ? itemIbPYPElementRatings
                            : ibPYPElementRatings,
                        }}
                        showStudentProfile={false}
                        isPreviewCard={true}
                        showSeeMore={true}
                        containerStyle={{
                          ...styles.responseContainerStyle,
                        }}
                        horizontalCardStyle={styles.responseHorizontalCardStyle}
                      />
                    </div>
                  }
                  showLeftArrow={true}
                  mainContentContainerStyle={{ marginBottom: "0" }}
                  headerStyle={{ padding: "0" }}
                />
              </div>
            )}
            {enableTagging && (
              <div className={classes.tagOptionContainer}>
                {showTagStudents && !isAddAllResponsesToJournal && (
                  <StudentTag
                    t={t}
                    onAddOrEditClick={() => this.goToStep("TAG_STUDENT")}
                    students={students}
                    isArchivedClass={isArchivedClass}
                    isCurrentAcademicYearSelected={
                      isCurrentAcademicYearSelected
                    }
                    isAIResponseGenerating={isAIResponseGenerating}
                    isPromptBoxContentPresent={isPromptBoxContentPresent}
                    userType={userType}
                    isPromptBoxTextPresent={isPromptBoxTextPresent}
                  />
                )}
                {showTagPYPElements && (
                  <div className={classes.pypElementDetail}>
                    <PYPElementTag
                      t={t}
                      onAddOrEditClick={
                        (!isCurrentAcademicYearSelected || isArchivedClass) &&
                        !_.size(students)
                          ? undefined
                          : onAddOrEditClickOfPYPElementTag
                      }
                      elementPYP={elementPYP}
                      unitPlan={unitPlan}
                      resourceItem={resourceItem}
                      resourceType={resourceType}
                      elementData={elementData}
                      isData={isData}
                      isLoading={isLoading}
                      showLoaderBar={false}
                      selectFromAllPYP={selectFromAllPYP}
                      taggableElements={taggableElements}
                      learningGoalsCount={learningGoalsCount}
                      goToStep={this.goToStep}
                      updatePost={updatePost}
                      showWarningModal={() =>
                        this.setState({ showGoalsRemovalWarningModal: true })
                      }
                      showTagLearningGoalsModal={showTagLearningGoalsModal}
                      isRecentPost={isRecentPost}
                      postsWithGoals={postsWithGoals}
                      isCurrentAcademicYearSelected={
                        isCurrentAcademicYearSelected
                      }
                      isArchivedClass={isArchivedClass}
                      disableTagLearningGoals={
                        (!isCurrentAcademicYearSelected || isArchivedClass) &&
                        !_.size(students)
                      }
                      isDeleteDisabled={
                        (!isCurrentAcademicYearSelected || isArchivedClass) &&
                        !_.size(students)
                      }
                      isAIResponseGenerating={isAIResponseGenerating}
                      isPromptBoxContentPresent={isPromptBoxContentPresent}
                      userType={userType}
                      isPromptBoxTextPresent={isPromptBoxTextPresent}
                    />
                  </div>
                )}
                {showRateonLearingGoals && (
                  <RateonLearningGoals
                    dataLength={_.size(postRatingsOfLearningGoals, 0)}
                    disabled={
                      learningGoalsCount == 0 ||
                      _.get(students, "length", 0) == 0 ||
                      isDisabledInMyp
                    }
                    toggleAlert={toggleAlert}
                    openRatingEditor={() => {
                      this.setState({ showLearningGoalsEditor: true });
                      updatePost({
                        academicTerm: { id: currentActiveTerm?.key },
                      });
                      setGlobalTrayEnabledState(false);
                    }}
                    setShowPostRatingModal={this.setShowPostRatingModal}
                    postRatingsOfLearningGoals={postRatingsOfLearningGoals}
                    studentsCount={_.size(students, 0)}
                    learningGoalsCount={learningGoalsCount}
                    isDisabledInMyp={isDisabledInMyp}
                    t={t}
                    isAIResponseGenerating={isAIResponseGenerating}
                    isPromptBoxContentPresent={isPromptBoxContentPresent}
                    userType={userType}
                    isPromptBoxTextPresent={isPromptBoxTextPresent}
                  />
                )}
                {showTagFolder && (
                  <FolderTags
                    t={t}
                    onAddOrEditClick={() => this.goToStep("TAG_FOLDERS")}
                    folders={folders}
                    addedFolders={addedFolders}
                    removedFolders={removedFolders}
                    isAIResponseGenerating={isAIResponseGenerating}
                    isPromptBoxContentPresent={isPromptBoxContentPresent}
                    userType={userType}
                    isPromptBoxTextPresent={isPromptBoxTextPresent}
                  />
                )}
                {showTagSnpV2 && totalNewSnpCycles ? (
                  <PracticesTagsV2
                    t={t}
                    postTitle={title}
                    taggedPractices={taggedPractices}
                    onAddOrEditClick={() => this.goToStep("TAG_PRACTICES_V2")}
                    isAIResponseGenerating={isAIResponseGenerating}
                    isPromptBoxContentPresent={isPromptBoxContentPresent}
                    userType={userType}
                    isPromptBoxTextPresent={isPromptBoxTextPresent}
                  />
                ) : null}
                {/* Show shared with section only to staffs */}
                {userType == "staff" && (
                  <TagStudents
                    {...screenPanelProps}
                    t={t}
                    goToStep={this.goToStep}
                    toggleAlert={toggleAlert}
                    isAIResponseGenerating={isAIResponseGenerating}
                    isPromptBoxContentPresent={isPromptBoxContentPresent}
                    userType={userType}
                    isPromptBoxTextPresent={isPromptBoxTextPresent}
                  />
                )}
              </div>
            )}
          </div>
          {showMediaModal &&
            (showNewTheatreMode() ? (
              <TheatreModeV2
                mediaAttachments={{ attachments: attachments }}
                activeAttachmentIndex={_.get(
                  this.state,
                  "currentAttachmentIndex",
                  0
                )}
                toggleTheatreMode={this.toggleMediaModal}
                iframeIdSelector={"workbook-iframe-dp-journal"}
                onDiscardDirectly={() => this.toggleMediaModal(false)}
              />
            ) : (
              <MediaModal
                toggleMediaModal={this.toggleMediaModal}
                attachments={
                  attachments.length ===
                  getAttachmentsByTypeFromAttachmentArr({
                    attachmentsArr: attachments,
                    type: "AUDIO",
                  }).length
                    ? attachments
                    : getAttachmentsByTypeFromAttachmentArr({
                        attachmentsArr: attachments,
                        type: "AUDIO",
                        except: true,
                      })
                }
              />
            ))}
        </ScreenPanel>
        {showTagModal && (
          //Open Tagging Screens in the Modal using Create Post itself

          <CreatePost
            currentStep={tagModalType}
            currentStepIndex={tagModalStepIndex}
            isInnerModal={true}
            onClose={this.onCloseTagModal}
            onDoneClick={this.onDoneClick}
            mode={mode}
          />
        )}
        {/* Post rate on learning goals editor/Preview */}
        {(this.state.showLearningGoalsEditor ||
          this.state.showPostRatingsModal) &&
          (enableTermRestriction() && !_.size(currentActiveTerms, 0) ? (
            <NoGradesConfiguredModal
              onClose={() => {
                this.setState({
                  showLearningGoalsEditor: false,
                  showPostRatingsModal: false,
                });
                setGlobalTrayEnabledState(true);
              }}
            />
          ) : (
            <PostRateonLearningGoals
              students={students}
              elementPYP={elementPYP}
              curriculumProgramType={_.get(
                this.props,
                "curriculumProgramType",
                CURRICULUM_TYPE_PYP
              )}
              showLearningGoalsEditor={_.get(
                this.state,
                "showLearningGoalsEditor",
                false
              )}
              onCloseClick={() => {
                this.setState({
                  showLearningGoalsEditor: false,
                  showPostRatingsModal: false,
                });
                setGlobalTrayEnabledState(true);
              }}
              mode={mode}
              showLearningGoalsPreview={this.state.showPostRatingsModal}
              setShowPostRatingsModal={this.setShowPostRatingModal}
              propsIbPypElementRatings={postRatingsOfLearningGoals}
              originalibPYPElementRatings={originalibPYPElementRatings}
              currentActiveTerms={currentActiveTerms}
              currentActiveTerm={currentActiveTerm}
            />
          ))}
        {this.state.showPostScheduleModal == true ? (
          <SchedulePostModal
            onClosePostScheduleModal={this.onCloseSchedulePostModal}
            editDateDetails={this.state.scheduleDateTimeDetails}
            onConfirmDateChange={this.onConfirmDateChange}
            canBackdate={_.includes(["PUBLISHED", "DRAFT"], state)}
            t={t}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

const mapActionCreators = {
  setToastMsg,
  setGlobalTrayEnabledState,
  enableGlobalHeader,
  disableGlobalHeader,
};

const getCurrentActiveTerm = _.memoize(
  ({ selectedActiveTerm, currentActiveTerm }) => {
    return {
      label: selectedActiveTerm
        ? selectedActiveTerm?.label
        : currentActiveTerm?.label,
      key: selectedActiveTerm ? selectedActiveTerm?.key : currentActiveTerm?.id,
    };
  },
  JSON.stringify
);

const formatCurrentActiveTerms = _.memoize(({ currentActiveTerms }) => {
  const getFormatDate = date => moment(date).format("Do MMM YYYY");
  return _.map(currentActiveTerms, term => {
    return {
      label: `${term.label} (${getFormatDate(term.startDate)} - ${getFormatDate(
        term.endDate
      )})`,
      key: term.id,
    };
  });
}, JSON.stringify);

const getUnitPlans = _.memoize(({ courseUnitPlans }) => {
  const unitPlans = [];
  _.forEach(courseUnitPlans, item => {
    if (!_.isEmpty(item.node)) {
      unitPlans.push(..._.get(item, "node", []));
    }
  });
  return unitPlans;
}, JSON.stringify);

const getOrganizationAcademicYears = _.memoize(
  ({ orgId, curriculumProgramId }) => {
    return {
      id: orgId,
      termsFilters: {
        curriculumProgramIds: curriculumProgramId
          ? [curriculumProgramId]
          : undefined,
      },
    };
  },
  JSON.stringify
);

const getPostFilters = _.memoize(({ userEntityType, studentIDs }) => {
  return {
    state: "PUBLISHED",
    showPrivate: true,
    isShowHiddenFromStudents: userEntityType === "STAFF",
    unTagged: false,
    orderBy: "PUBLISHED_AT",
    onlyLearningGoalTaggedPost: true,
    studentIds: studentIDs,
  };
}, JSON.stringify);

const mapStateToProps = (state, ownProps) => {
  const userInfo = getUserInfo();
  const progressOfUploads = state.app_services.progressOfUploads;
  const isUploading = !_.isEmpty(progressOfUploads);
  const postDetails = ownProps.screenPanelProps.postDetails;
  const updatePost = ownProps.screenPanelProps.updatePost;
  const isSnpV2Enabled = ownProps.screenPanelProps.isSnpV2Enabled;
  const {
    unitPlan = BLANK_OBJECT,
    elementPYP = BLANK_ARRAY,
    studentIds = [],
  } = postDetails;

  const subjects = _.get(unitPlan, "subjects.value", BLANK_ARRAY);
  let grades = _.get(unitPlan, "grades", BLANK_ARRAY);
  const selectedGrades = state.teacher?.selected_class?.selected_grades;

  let selectFromAllPYP = postDetails?.selectFromAllPYP;
  if (!selectFromAllPYP && !_.isEmpty(elementPYP) && _.isEmpty(unitPlan))
    selectFromAllPYP = true;

  if (selectFromAllPYP) grades = selectedGrades;
  const taggedBenchmarksValue = _.get(
    _.find(elementPYP, item => item.fieldUID == "benchmarks"),
    "value",
    BLANK_ARRAY
  );
  const userType = userInfo.user_type;
  const curriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );
  const curriculumProgramId = state.platform.currentCurriculumProgram.id;
  const activeTermId = state.post.postDetails.academicTerm?.id;
  const postRatingsOfLearningGoals = _.get(
    postDetails,
    "ibPYPElementRatings",
    BLANK_ARRAY
  );
  const originalibPYPElementRatings = _.get(
    postDetails,
    "originalibPYPElementRatings",
    BLANK_ARRAY
  );

  //  show tag pyp elements section to user based on setting
  const showTagPYPElements =
    getSettingValue({
      name: "EnablePYPElementsTaggingInPostByStudents",
      courseId: state.teacher.selected_class.selected_course,
      organizationId: userInfo.org_id,
      userId: userInfo.id,
      userEntityType: userInfo.userEntityType,
    }) || userType != "student";
  const showTagStudents =
    getSettingValue({
      name: "EnableStudentTaggingInPostCreationForStudents",
      courseId: state.teacher.selected_class.selected_course,
      organizationId: userInfo.org_id,
      userId: userInfo.id,
      userEntityType: userInfo.userEntityType,
    }) || userType !== "student";
  const showTagFolder =
    getSettingValue({
      name: "EnableTaggingFolderInPostByStudents",
      courseId: state.teacher.selected_class.selected_course,
      organizationId: userInfo.org_id,
      userId: userInfo.id,
      userEntityType: userInfo.userEntityType,
    }) || userType !== "student";
  const isApprovalRequiredForStudentPosts =
    getSettingValue({
      name: "EnablePostApprovalRequiredForNewStudents",
      courseId: state.teacher.selected_class.selected_course,
      organizationId: userInfo.org_id,
      userId: userInfo.id,
      userEntityType: userInfo.userEntityType,
    }) || userType != "student";
  const isCurrentAcademicYearSelected =
    _.get(state, "platform.academicYearSelected.isCurrentAcademicYear", true) ||
    getSettingValue({
      name: "EnablePreviousAYPostCreation",
      userId: userInfo.id,
      readFromUserAndOrgLevel: true,
    }); // Special case: Allowing support people for previous AY post creation on behalf of staffs
  const plannerElementSets = _.get(
    state,
    "platform.currentPlannerElementSets",
    BLANK_ARRAY
  );
  const textAreaTitle = !(
    _.isEqual(_.get(postDetails, "title", ""), "null") ||
    _.isEqual(_.get(postDetails, "title", ""), "undefined")
  )
    ? _.get(postDetails, "title", "")
    : "";

  const showRateonLearingGoals =
    userType === "staff" &&
    getSettingValue({
      name: "EnablePostRatingOnLearningGoals",
      courseId: state?.teacher?.selected_class?.selected_course,
      organizationId: userInfo?.org_id,
      userId: userInfo?.id,
      userEntityType: userInfo?.userEntityType,
    }) &&
    !_.get(
      ownProps,
      "screenPanelProps.postDetails.isAddAllResponsesToJournal",
      false
    );

  const courseId = _.isEmpty(
    _.get(state, "teacher.selected_class.selected_course", "")
  )
    ? _.get(state, "post.postDetails.courseId")
    : _.get(state, "teacher.selected_class.selected_course", "");
  const canScheduleAPost =
    userType == "staff" &&
    _.get(ownProps, "screenPanelProps.mode", "") == "create";

  const organizationAcademicYearsVariables = getOrganizationAcademicYears({
    orgId: userInfo.org_id,
    curriculumProgramId,
  });

  const userId = _.get(userInfo, "id");
  const userEntityType = _.get(userInfo, "userEntityType");
  const studentIDs = [];
  if (userEntityType === "STUDENT") {
    studentIDs.push(userId);
  }

  const postCount = 3;
  const typeForPostQuery = "COURSE";

  const postFilters = getPostFilters({ userEntityType, studentIDs });
  const gradeId = _.get(
    state,
    "teacher.selected_class.selected_grades[0]",
    BLANK_STRING
  );
  const postType = _.get(state, "post.postDetails.postType", BLANK_STRING);
  const isAIResponseGenerating = _.get(
    state,
    "post.postDetails.isAIResponseGenerating",
    false
  );
  const isPromptBoxContentPresent = _.get(
    state,
    "post.postDetails.isPromptBoxContentPresent",
    false
  );

  const isPromptBoxTextPresent = _.get(
    state,
    "post.postDetails.isPromptBoxTextPresent",
    false
  );
  const defaultStudentIdentifierNamePreference = getDefaultStudentIdentifierNamePreference(
    state
  );
  return {
    userType: userType,
    isData: true,
    isLoading: false,
    unitPlan: unitPlan,
    studentIds,
    grades,
    subjects,
    elementPYP,
    organizationId: userInfo.org_id,
    taggedBenchmarksValue,
    showTagPYPElements,
    showTagSnpV2: isSnpV2Enabled,
    elementData: getElementData({
      isPost: true,
      elements: elementPYP,
      field_list: getFieldList({ curriculumProgramType }),
      unitPlanFields: _.get(unitPlan, "fields", BLANK_OBJECT),
      deriveSubjectIdsFromNodes: true,
    }),
    showLoaderBar: false,
    showTagStudents,
    selectFromAllPYP,
    showTagFolder,
    showRateonLearingGoals,
    isApprovalRequiredForStudentPosts,
    taggableElements: getTaggableElements({
      curriculumProgramType,
      unitPlan,
      plannerElementSets,
    }),
    isCurrentAcademicYearSelected,
    textAreaTitle,
    updatePost,
    isArchivedClass: _.get(state, "teacher.selected_class.isArchivedClass"),
    isUploading,
    curriculumProgramType,
    postRatingsOfLearningGoals,
    originalibPYPElementRatings,
    courseId,
    canScheduleAPost: canScheduleAPost,
    organizationAcademicYearsVariables,
    activeTermId,
    postCount,
    typeForPostQuery,
    postFilters,
    gradeId,
    curriculumProgramId,
    postType,
    isAIResponseGenerating,
    isPromptBoxContentPresent,
    isPromptBoxTextPresent,
    defaultStudentIdentifierNamePreference,
  };
};

export default compose(
  I18nHOC({ resource: ["journal", "common"] }),
  connect(mapStateToProps, mapActionCreators),
  graphql(getStudentAssignmentDetailsQuery, {
    skip: ({
      screenPanelProps: { isAddLEToJournal, isAddAllResponsesToJournal, mode },
    }) => mode === "edit" || !isAddLEToJournal || isAddAllResponsesToJournal,
    name: "getStudentAssignmentDetails",
    options: ({
      screenPanelProps: {
        postDetails: { studentAssignmentId, isSharedWithStudent },
      },
      userType,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: studentAssignmentId,
        showOnlySubmitted: false,
        userFilter: getToolResponseUserFilter(userType, isSharedWithStudent),
        entityEventsFilter: {
          orderBy: "EVENT_TIME",
          orderByDir: "ASC",
        },
      },
    }),
    props({ getStudentAssignmentDetails }) {
      const studentAssignmentData = getStudentAssignmentDetailsFromCache(
        getStudentAssignmentDetails.variables
      );

      const toolResponses = _.get(
        studentAssignmentData,
        "toolResponses",
        BLANK_OBJECT
      );
      const ibPYPElementRatings = _.get(
        studentAssignmentData,
        "ibPYPElementRatings",
        BLANK_ARRAY
      );
      return {
        toolResponses,
        ibPYPElementRatings,
      };
    },
  }),
  graphql(getCourseUnitQuery, {
    name: "getCourseUnit",
    skip: ({ courseId }) => _.isNil(courseId) || _.isEmpty(courseId),
    options: ({ courseId, userType }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        filters: {
          searchText: "",
          isShowPrivate: true,
          showAllPublishedUnits: userType === "student",
        },
        id: courseId,
        groupBy: "UNIT_TYPE",
      },
    }),
    props({ getCourseUnit, ownProps: { courseId, userType } }) {
      const courseDetail = getCourseUnitFromCache({
        filters: {
          searchText: "",
          isShowPrivate: true,
          showAllPublishedUnits: userType === "student",
        },
        id: courseId,
        groupBy: "UNIT_TYPE",
      });
      return {
        courseUnitPlans: getUnitPlans({
          courseUnitPlans: _.get(courseDetail, "unitPlans.edges", BLANK_ARRAY),
        }),
        isData: !_.isEmpty(courseDetail),
        isLoading:
          getCourseUnit["networkStatus"] == 1 ||
          getCourseUnit["networkStatus"] == 2,
      };
    },
  }),
  graphql(getOrganizationAcademicYearsQuery, {
    name: "getOrganizationAcademicYears",
    skip: ({ organizationId }) => !organizationId,
    options: ({ organizationAcademicYearsVariables }) => ({
      fetchPolicy: "cache-and-network",
      variables: organizationAcademicYearsVariables,
    }),
    props({
      getOrganizationAcademicYears,
      ownProps: { organizationAcademicYearsVariables, activeTermId, isData },
    }) {
      const data = getOrganizationAcademicYearsFromCache(
        organizationAcademicYearsVariables
      );
      const currentAcademicYear = _.filter(
        _.get(data, "node.academicYears", BLANK_ARRAY),
        item => item?.isCurrentAcademicYear
      );
      let currentActiveTerms = [];
      _.forEach(currentAcademicYear, item => {
        !_.isNil(item.terms) && currentActiveTerms.push(...item.terms);
      });
      const getFormatDate = date => moment(date).format("Do MMM YYYY");
      const currentActiveTerm = getCurrentTerm({ terms: currentActiveTerms });
      currentActiveTerms = formatCurrentActiveTerms({ currentActiveTerms });

      const selectedActiveTerm = _.find(
        currentActiveTerms,
        term => term.key === activeTermId
      );

      // Note:This will either select the current active term or the term which is selected by the user.
      return {
        currentActiveTerms,
        currentActiveTerm: getCurrentActiveTerm({
          selectedActiveTerm,
          currentActiveTerm,
        }),
        isData: !_.isEmpty(currentActiveTerms) || isData,
        isLoading:
          getOrganizationAcademicYears["networkStatus"] == 1 ||
          getOrganizationAcademicYears["networkStatus"] == 2,
      };
    },
  }),
  graphql(getPostsHavingTaggedGoalsQuery, {
    name: "getPostsHavingTaggedGoals",
    skip: ({ courseId }) => !courseId,
    options: ({ courseId, postCount, postFilters, typeForPostQuery }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: courseId,
        last: postCount,
        filters: postFilters,
        type: typeForPostQuery,
      },
    }),
    props: ({
      getPostsHavingTaggedGoals,
      ownProps: {
        courseId,
        postCount,
        postFilters,
        typeForPostQuery,
        isData,
        isLoading,
      },
    }) => {
      const postsData = getPostsHavingTaggedGoalsQueryFromCache({
        courseId,
        postCount,
        postFilters,
        typeForPostQuery,
      });
      const postsWithGoals = _.get(postsData, "node.posts", BLANK_ARRAY);
      return {
        postsWithGoals: postsWithGoals,
        isRecentPost: _.size(_.get(postsWithGoals, "edges", BLANK_ARRAY)) > 0,
        // getPostsHavingTaggedGoals, //Removing not used
        isLoading:
          getPostsHavingTaggedGoals.networkStatus === 1 ||
          getPostsHavingTaggedGoals.networkStatus === 2 ||
          isLoading,
      };
    },
  })
)(AddPostDetails);
AddPostDetails.displayName = "AddPostDetails";
